"use strict";
const isTouchDevice = () => "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

/**
 * Trustpilot's
 */
const reinitTrustpilotWidgets = (scope = document) => {
  if (!window.Trustpilot || typeof window.Trustpilot.loadFromElement !== "function") {
    return;
  }

  scope.querySelectorAll(".trustpilot-widget").forEach((widget) => {
    window.Trustpilot.loadFromElement(widget, true);
  });
};

if (isTouchDevice()) {
    const e = document.querySelectorAll(".has-sub-menu > a");
    e.forEach((t) => {
        t.addEventListener("click", (i) => {
            isTouchDevice() &&
                (e.forEach((e) => {
                    e !== t && e.classList.remove("is-dropdown-open");
                }),
                t.classList.contains("is-dropdown-open") || (i.preventDefault(), t.classList.add("is-dropdown-open")));
        });
    });
}

class DropdownModal extends HTMLElement {
    constructor() {
        super(),
            (this.eventPrefix = this.dataset.eventPrefix),
            (this.toggles = this.querySelectorAll(".dropdown-modal-toggle")),
            (this.content = this.querySelector(".dropdown-modal-toggle + div")),
            (this.preventOpen = "true" === this.getAttribute("prevent-open")),
            this.preventOpen ||
                (this.addEventListener("keyup", (e) => {
                    "ESCAPE" === e.code.toUpperCase() && this.close();
                }),
                this.toggles.forEach((e) => {
                    e.addEventListener("click", this.handleToggle.bind(this));
                }));
    }
    isOpen() {
        return "true" === this.getAttribute("open");
    }
    handleToggle(e) {
        e?.preventDefault?.(), this.isOpen() ? this.close() : this.open();
    }
    open(e) {
        (this.openedBy = e),
            this.setAttribute("open", !0),
            this.toggles.forEach((e) => {
                e.setAttribute("aria-expanded", !0);
            }),
            trapFocus(this),
            this.eventPrefix && publish(`${this.eventPrefix}:open`),
            document.querySelectorAll("localization-form")?.forEach?.((e) => {
                e?.hidePanel?.();
            });
    }
    close() {
        this.toggles.forEach((e) => {
            e.setAttribute("aria-expanded", !1);
        }),
            this.removeAttribute("open"),
            this.openedBy && removeTrapFocus(this.openedBy),
            this.eventPrefix && publish(`${this.eventPrefix}:close`);
    }
}
customElements.define("dropdown-modal", DropdownModal);
class HeaderSearchDropdownModal extends DropdownModal {
    constructor() {
        super(), (this.searchInput = this.querySelector('input[type="search"]'));
    }
    open(e) {
        super.open(e), trapFocus(this, this.searchInput);
    }
}
customElements.define("header-search-dropdown-modal", HeaderSearchDropdownModal);
const navigations = document.querySelectorAll(".navigation-menu");
navigations.forEach((e) => {
    const t = e.querySelectorAll(":scope > .has-sub-menu"),
        i = (e, t = 0) => {
            const n = e && e.querySelector(".navigation-sub-menu");
            return n ? i(n, t + n.clientWidth) : t;
        },
        n = () => {
            const e = window.innerWidth;
            t.forEach((t) => {
                if (t.classList.contains("navigation-item-static")) return;
                t.classList.remove("nav-open-left");
                const n = i(t);
                t.offsetLeft + n > e && t.classList.add("nav-open-left");
            });
        };
    let r;
    n(),
        window.addEventListener("resize", () => {
            clearTimeout(r),
                (r = setTimeout(() => {
                    n();
                }, 350));
        });
});
const sidebarDrawerButton = document.querySelector(".button-sidebar-drawer-open"),
    sidebarDrawer = document.querySelector(".page-layout-sidebar"),
    handleSidebarOpen = () => {
        document.body.classList.add("page-layout-sidebar-drawer-open"),
            document.body.classList.add("overflow-hidden-tablet"),
            trapFocus(sidebarDrawer, sidebarDrawer.querySelector(".page-layout-sidebar-drawer-header"));
    },
    handleSidebarDismiss = () => {
        document.body.classList.remove("page-layout-sidebar-drawer-open"),
            document.body.classList.remove("overflow-hidden-tablet"),
            removeTrapFocus(sidebarDrawerButton);
    },
    isSidebarOpen = () => document.body.classList.contains("page-layout-sidebar-drawer-open");
sidebarDrawerButton &&
    sidebarDrawer &&
    (document.body.addEventListener("click", (e) => {
        const { target: t } = e;
        t.classList.contains("js-button-sidebar-drawer-dismiss")
            ? handleSidebarDismiss()
            : t.classList.contains("button-sidebar-drawer-open")
              ? handleSidebarOpen()
              : isSidebarOpen() && !t.closest(".page-layout-sidebar") && (handleSidebarDismiss(), e.preventDefault());
    }),
    sidebarDrawer.addEventListener("keyup", (e) => {
        "ESCAPE" === e.code.toUpperCase() && handleSidebarDismiss();
    })),
    document.addEventListener("change", (e) => {
        if (e.target.parentNode?.classList.contains("select-custom")) {
            const t = e.target;
            t.parentNode.querySelector("label").textContent = t.options[t.selectedIndex].text;
        }
    }),
    (() => {
        const e = document.querySelectorAll('a[href*="#product-reviews"]'),
            t = document.getElementById("product-reviews");
        e &&
            t &&
            e.forEach((e) => {
                e.addEventListener("click", () => {
                    t.expand();
                });
            }),
            "#product-reviews" === window.location.hash &&
                t &&
                (setTimeout(() => {
                    t.expand();
                }, 0),
                setTimeout(() => {
                    t.scrollIntoView();
                }, 200));
    })(),
    (() => {
        const e = document.querySelectorAll(".star-rating-badge"),
            t = document.getElementById("product-reviews");
        e.length > 0 &&
            t &&
            e.forEach((e) => {
                e.classList.contains("star-rating-link") ||
                    e.addEventListener("click", () => {
                        t.expand();
                    });
            }),
            e.length > 0 &&
                !t &&
                e.forEach((e) => {
                    if (e.classList.contains("star-rating-link")) return;
                    const t = e.closest(".card-product");
                    if (t) {
                        const i = t.querySelector(".card-heading > a")?.getAttribute("href");
                        e.addEventListener("click", () => {
                            window.location = `${i}#product-reviews`;
                        });
                    }
                });
    })();
class CollapsibleExpandable extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        (this.collapsed = "false" === this.getAttribute("expanded")),
            (this.toggleElement = this.querySelector(".facet-toggle")),
            (this.onToggle = this.onToggle.bind(this)),
            this.toggleElement.addEventListener("click", this.onToggle),
            (this.list = this.querySelector(".facet-options-list")),
            (this.listCollapsed = this.list && "false" === this.list.getAttribute("aria-expanded")),
            (this.expandListToggle = this.querySelector(".facet-button-more")),
            (this.onListToggle = this.onListToggle.bind(this)),
            this.expandListToggle && this.expandListToggle.addEventListener("click", this.onListToggle),
            (this.shouldCollapseOthers = "true" === this.dataset.collapseOthers);
    }
    disconnectedCallback() {
        this.toggleElement.removeEventListener("click", this.onToggle),
            this.expandListToggle && this.expandListToggle.removeEventListener("click", this.onListToggle());
    }
    onToggle(e) {
        e.preventDefault(), this.handleToggle();
    }
    collapse() {
        this.setAttribute("expanded", "false"),
            this.toggleElement.setAttribute("aria-expanded", "false"),
            (this.collapsed = !0);
    }
    expand() {
        this.setAttribute("expanded", "true"),
            this.toggleElement.setAttribute("aria-expanded", "true"),
            (this.collapsed = !1);
    }
    collapseOthers() {
        for (const e of this.parentElement.children)
            e !== this && "COLLAPSIBLE-EXPANDABLE" === e.tagName && e.collapse();
        const e = this.getBoundingClientRect(),
            t = document.querySelector(".section-header-sticky"),
            i = t ? t.offsetHeight : 0;
        if (!(e.top >= i && e.top <= window.innerHeight)) {
            const t = window.scrollY + e.top - i;
            window.scrollTo({ top: t, behavior: "smooth" });
        }
    }
    handleToggle() {
        this.collapsed ? (this.expand(), this.shouldCollapseOthers && this.collapseOthers()) : this.collapse();
    }
    onListToggle(e) {
        e && e.preventDefault(), this.handleToggleList();
    }
    collapseList() {
        this.list && this.list.setAttribute("aria-expanded", "false"),
            this.expandListToggle &&
                (this.expandListToggle.innerHTML = "&plus; " + window.productsStrings.facetsShowMore),
            (this.listCollapsed = !0);
    }
    expandList() {
        this.list && this.list.setAttribute("aria-expanded", "true"),
            this.expandListToggle &&
                (this.expandListToggle.innerHTML = "&minus; " + window.productsStrings.facetsShowLess),
            (this.listCollapsed = !1);
    }
    handleToggleList() {
        this.listCollapsed ? this.expandList() : this.collapseList();
    }
}
customElements.define("collapsible-expandable", CollapsibleExpandable);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]')?.addEventListener("click", this.hide.bind(this)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      "MODAL-DIALOG" === e.target.nodeName && this.hide();
                  });
    }
    connectedCallback() {
        this.moved || Shopify.designMode || ((this.moved = !0), document.body.appendChild(this));
    }
    show(e) {
        (this.openedBy = e),
            document.body.classList.add("overflow-hidden"),
            this.setAttribute("open", ""),
            trapFocus(this, this.querySelector('[role="dialog"]')),
            window.pauseAllMedia();
    }
    hide() {
        document.body.classList.remove("overflow-hidden"),
            this.removeAttribute("open"),
            this.openedBy && removeTrapFocus(this.openedBy),
            window.pauseAllMedia();
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("button");
        e &&
            e.addEventListener("click", () => {
                const t = document.querySelector(this.getAttribute("data-modal"));
                t && t.show(e);
            });
    }
}
customElements.define("modal-opener", ModalOpener);
class HTMLUpdateUtility {
    #e = [];
    #t = [];
    constructor() {}
    addPreProcessCallback(e) {
        this.#e.push(e);
    }
    addPostProcessCallback(e) {
        this.#t.push(e);
    }
    viewTransition(e, t) {
        this.#e.forEach((e) => e(t));
        const i = document.createElement("div");
        HTMLUpdateUtility.setInnerHTML(i, t.outerHTML);
        const n = i.firstChild;
        e.parentNode.insertBefore(n, e), (e.style.display = "none");
        const r = Date.now();
        e.querySelectorAll("[id], [form]").forEach((e) => {
            e.id && (e.id = `${e.id}-${r}`), e.form && e.setAttribute("form", `${e.form.getAttribute("id")}-${r}`);
        }),
            this.#t.forEach((e) => e(n)),
            setTimeout(() => e.remove(), 500);
    }
    static setInnerHTML(e, t) {
        (e.innerHTML = t),
            e.querySelectorAll("script").forEach((e) => {
                const t = document.createElement("script");
                Array.from(e.attributes).forEach((e) => {
                    t.setAttribute(e.name, e.value);
                }),
                    t.appendChild(document.createTextNode(e.innerHTML)),
                    e.parentNode.replaceChild(t, e);
            });
    }
}
class VariantSelects extends HTMLElement {
    constructor() {
        super(),
            this.initializeProductSwapUtility(),
            this.addEventListener("change", this.handleProductUpdate),
            (this.sectionId = this.dataset.section),
            (this.hideOutOfStock = "hide" === this.dataset.variantsVisibility),
            (this.hideSingle = "true" === this.dataset.hideSingle),
            (this.optionsWithValues = JSON.parse(
                this.querySelector('[type="application/json"][data-id="product-options-with-values"]').textContent
            )),
            (this.variants = JSON.parse(
                this.querySelector('[type="application/json"][data-id="product-variants"]')?.textContent ?? null
            )),
            this.updateVisibility();
    }
    initializeProductSwapUtility() {
        (this.swapProductUtility = new HTMLUpdateUtility()),
            this.swapProductUtility.addPostProcessCallback((e) => {
                window?.Shopify?.PaymentButton?.init(),
                    window?.ProductModel?.loadShopifyXR(),

                    //Trustpilot's
                    reinitTrustpilotWidgets(e);

                    publish(PUB_SUB_EVENTS.sectionRefreshed, {
                        data: {
                            sectionId: this.sectionId,
                            resource: {
                                type: "product",
                                id: e.querySelector("variant-selects, variant-radios").dataset.productId,
                            },
                        },
                    });
            });
    }
    updateDropdownDisplayImmediately(e) {
        if (!e) return;
        const t = "SELECT" === e.tagName ? e : e.closest("select");
        if (!t) return;
        const i = t.closest(".product-form-input-dropdown"),
            n = i?.querySelector(".variant-card__display .variant-card__value");
        if (n) {
            const e = t.selectedOptions?.[0];
            n.innerText = e ? e.text.trim() : t.value;
        }
    }
    handleProductUpdate(e) {
        const t = this.getInputForEventTarget(e.target),
            i = t.id,
            n = t.dataset.productUrl || this.dataset.url,
            r = this.sectionId,
            s = window.scrollY,
            o = document.documentElement,
            a = o.style.scrollBehavior;
        o.style.scrollBehavior = "auto";
        let c = !0;
        const l = () => {
            c && window.scrollY !== s && window.scrollTo(0, s);
        };
        window.addEventListener("scroll", l, { passive: !0 });
        const d = () => {
            c && ((c = !1), window.removeEventListener("scroll", l), (o.style.scrollBehavior = a));
        };
        document.activeElement && "function" == typeof document.activeElement.blur && document.activeElement.blur(),
            this.updateDropdownDisplayImmediately(t),
            (this.currentVariant = this.getVariantData(i)),
            (this.currentVariant = this.maybeGetFirstAvailableVariant(this.currentVariant, t)),
            (this.hideVariants = "true" === this.dataset.hideVariants);
        let u = this.getProductInfoUrl(n, this.currentVariant?.id);
        if (this.closest("quick-view-drawer")) return d(), void this.handleQuickviewUpdate(u, i);
        this.toggleAddButton(!0, "");
        let h = () => {};
        if (this.dataset.url !== n || (this.hideVariants && this.currentVariant)) {
            this.updateURL(n), this.updateShareUrl(n), (h = this.handleSwapProduct(r));
            const e = "true" === this.dataset.updateUrl;
            u = this.getProductInfoUrl(n, this.currentVariant?.id, e);
        } else
            this.currentVariant
                ? (this.updateMedia(),
                  this.updateURL(n),
                  this.updateShareUrl(n),
                  this.updateVariantInput(),
                  (h = this.handleUpdateProductInfo(r).bind(this)))
                : (this.setUnavailable(),
                  (h = (e) => {
                      this.updatePickupAvailability(), this.updateOptionValues(e);
                  }));
        this.renderProductInfo(u, i, (e) => {
            h(e), window.scrollTo(0, s);
        }),
            setTimeout(d, 700);
    }
    maybeGetFirstAvailableVariant(e, t) {
        let i = e;
        if (this.variants && this.hideOutOfStock && (!e || !e.available)) {
            const e = t.closest("fieldset, select").dataset.optionPosition,
                n = Array.from(this.querySelectorAll("fieldset input:checked, select option:checked")).reduce(
                    (e, t) => (e.push(t.value), e),
                    []
                ),
                r = this.variants.find((t) => {
                    const i = t.options.slice(0, e).toString(),
                        r = n.slice(0, e).toString();
                    return t.available && i === r;
                });
            r && (i = r);
        }
        return i;
    }
    getInputForEventTarget(e) {
        return "SELECT" === e.tagName ? e.selectedOptions[0] : e;
    }
    getWrappingSection(e) {
        return this.closest(`#shopify-section-${e}`) || null;
    }
    handleSwapProduct(e) {
        return (t) => {
            const i = this.getWrappingSection(e);
            if (!i) return;
            document.getElementById(`ProductModal-${e}`)?.remove();
            const n = t.getElementById(`shopify-section-${e}`);
            "true" === this.dataset.updateUrl
                ? (this.swapProductUtility.viewTransition(document.querySelector("main"), t.querySelector("main")),
                  (document.querySelector("head title").innerHTML = t.querySelector("head title").innerHTML))
                : this.swapProductUtility.viewTransition(i, n);
        };
    }
    handleQuickviewUpdate(e, t) {
        const i = this.closest("quick-view-drawer"),
            n = i.querySelector("product-form form");
        n && (n.style.opacity = "0.7"),
            this.renderProductInfo(e, t, (e) => {
                i.renderProduct(e, this.currentVariant);
            });
    }
    updateMedia() {
        const e = document.getElementById(`MediaGallery-${this.dataset.section}`);
        this.currentVariant &&
            this.currentVariant.featured_media &&
            e?.setActiveMedia &&
            e.setActiveMedia(this.currentVariant.featured_media.id, "true" === e.getAttribute("hide-variants"));
    }
    updateURL(e) {
        this.currentVariant &&
            "false" !== this.dataset.updateUrl &&
            window.history.replaceState(
                {},
                "",
                `${e}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""}`
            );
    }
    updateShareUrl(e) {
        const t = document.querySelectorAll(`Product-${this.dataset.section} .list-social-item a`);
        t &&
            t.forEach((t) => {
                const i = `${window.shopUrl}${e}${this.currentVariant?.id ? `?variant=${this.currentVariant.id}` : ""}`;
                t.href = `${t.dataset.shareUrl}${encodeURIComponent(i)}`;
            });
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`).forEach((e) => {
            const t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e &&
            e.fetchAvailability &&
            (this.currentVariant && this.currentVariant.available
                ? e.fetchAvailability(this.currentVariant.id)
                : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    updateVisibility() {
        const e = this.closest(".product-variants"),
            t = Array.from(this.querySelectorAll("fieldset[data-option-position], select[data-option-position]") ?? []),
            i =
                t.length > 0 &&
                t.every((e) => {
                    if ("SELECT" === e.tagName) {
                        return (
                            1 ===
                            Array.from(e.querySelectorAll("option")).filter((e) => !e.hidden && !e.disabled).length
                        );
                    }
                    return 1 === e.querySelectorAll("input, option").length;
                }),
            n =
                t.length > 0 &&
                t.every((e) => {
                    if ("SELECT" === e.tagName) {
                        return (
                            1 ===
                            Array.from(e.querySelectorAll('[data-variant-available="true"]')).filter(
                                (e) => !e.hidden && !e.disabled
                            ).length
                        );
                    }
                    return 1 === e.querySelectorAll('[data-variant-available="true"]').length;
                });
        this.hideSingle && (i || (this.hideOutOfStock && n))
            ? e?.classList.add("hidden")
            : (e?.classList.remove("hidden"),
              e?.classList.add("variants-visible"),
              e?.classList.remove("variants-hidden"));
    }
    updateOptionValues(e) {
        const t = e.querySelector("variant-selects, variant-radios");
        if (!t) return;
        this.querySelectorAll("[data-option-position]").forEach((e) => {
            const i = e.dataset.optionPosition,
                n = t.querySelector(`[data-option-position="${i}"]`);
            if (n)
                if ("SELECT" === e.tagName && "SELECT" === n.tagName) {
                    const t = e.value;
                    (e.innerHTML = n.innerHTML),
                        Array.from(e.querySelectorAll("option")).forEach((e) => {
                            "false" === e.dataset.variantAvailable && ((e.disabled = !0), (e.hidden = !0));
                        });
                    if (Array.from(e.options).find((e) => e.value === t && !e.hidden && !e.disabled)) e.value = t;
                    else {
                        const t = Array.from(e.options).find((e) => !e.hidden && !e.disabled);
                        t && ((e.value = t.value), e.dispatchEvent(new Event("change", { bubbles: !0 })));
                    }
                    const i = e.closest(".product-form-input-dropdown"),
                        r = i?.querySelector(".variant-card__display .variant-card__value");
                    if (r) {
                        const t = e.selectedOptions?.[0];
                        t && (r.innerText = t.text.trim());
                    }
                } else if ("FIELDSET" === e.tagName && "FIELDSET" === n.tagName) {
                    const t = e.querySelector("div"),
                        i = n.querySelector("div");
                    t && i && (t.innerHTML = i.innerHTML);
                }
        }),
            this.updateVisibility();
    }
    getProductInfoUrl(e, t, i = !1) {
        const n = [];
        if ((i || n.push(`section_id=${this.sectionId}`), t)) n.push(`variant=${t}`);
        else {
            const e = this.getSelectedOptionValues();
            e.length && n.push(`option_values=${e.join(",")}`);
        }
        return `${e}?${n.join("&")}`;
    }
    runVariantSideEffectApis(e) {
        if (this.closest("quick-view-drawer")) return;
        if (!e.querySelector(".product-block-product-form")) return;
        const t = document.querySelector(".online-store-inventory"),
            i = document.querySelector(".pickup-store-inventory"),
            n = window.ShopifyTranslations?.onlineStoreQtyUnavailableText ?? "",
            r = window.ShopifyTranslations?.pickupStoreQtyUnavailableText ?? "";
        t && (t.innerHTML = `<span class="status-pill unavailable">0</span> ${n}`),
            i && (i.innerHTML = `<span class="status-pill unavailable">0</span> ${r}`);
        const s = e.querySelector(".product-main-sku > span");
        let o = "";
        s && !s.closest(".visually-hide") && (o = s.textContent.trim());
        const a = /^[0-9]+$/.test(o) ? o.padStart(10, "0") : "";
        let c = "";
        const l = e.querySelector(".product-main-sku");
        l && !l.closest(".visually-hide") && (c = l?.dataset?.asposproductid || "");
        const d = [];
        a && "function" == typeof productInventoryApi && d.push(Promise.resolve().then(() => productInventoryApi(a))),
            "function" == typeof productShelfLocationAPI &&
                d.push(Promise.resolve().then(() => productShelfLocationAPI(a, c))),
            "function" == typeof kluslistProductDetailPageAPI &&
                d.push(Promise.resolve().then(() => kluslistProductDetailPageAPI())),
            Promise.allSettled(d);
    }
    renderProductInfo(e, t, i) {
        this.abortController?.abort(),
            (this.abortController = new AbortController()),
            fetch(e, { signal: this.abortController.signal })
                .then((e) => e.text())
                .then((e) => {
                    const t = new DOMParser().parseFromString(e, "text/html");
                    i(t), this.runVariantSideEffectApis(t);
                })
                .catch((e) => {
                    "AbortError" !== e.name && console.error("Variant fetch failed:", e);
                });
    }
    handleUpdateProductInfo(e) {
        return (t) => {
            const i = `price-${e}`,
                n = `ProductAvailability-${e}`,
                r = `ProductHeading-${e}`,
                s = document.getElementById(i),
                o = t.getElementById(i),
                a = t.getElementById(r),
                c = document.getElementById(r),
                l = document.getElementById(n),
                d = t.getElementById(n),
                u = t.getElementById(`product-form-${e}`)?.closest("product-form"),
                h = document.getElementById(`product-form-${e}`)?.closest("product-form"),
                p = t.getElementById(`ProductStockBar-${e}`),
                m = document.getElementById(`ProductStockBar-${e}`),
                y = t.getElementById(`ProductSignup-${e}`),
                g = document.getElementById(`ProductSignup-${e}`),
                f = t.getElementById(`ProductCountdown-${e}`),
                v = document.getElementById(`ProductCountdown-${e}`);
            o && s && (s.innerHTML = o.innerHTML),
                d && l && (l.innerHTML = d.innerHTML),
                a && c && (c.innerHTML = a.innerHTML);
            const b = document.getElementById(`price-${e}`),
                S = document.querySelectorAll(`.product-info-meta-${this.dataset.section}`);
            b && b.classList.remove("visibility-hidden"),
                S.length > 0 &&
                    S.forEach((e) => {
                        e.classList.remove("visibility-hidden");
                    }),
                u && h && (h.outerHTML = u.outerHTML),
                p && m && ((m.innerHTML = p.innerHTML), m.classList.remove("hidden")),
                y && g && (g.outerHTML = y.outerHTML),
                f && v && (v.outerHTML = f.outerHTML);
            const w = document.querySelectorAll(`.product-block-content-${e}.variant-changed-update`),
                E = t.querySelectorAll(`.product-block-content-${e}.variant-changed-update`);
            if (
                (w.forEach((e, t) => {
                    const i = E[t];
                    i ? (e.outerHTML = i.outerHTML) : e.remove();
                }),
                E.length > w.length)
            ) {
                const t = document.querySelector(`#ProductPage-${e} .product-info-description-content`);
                t &&
                    E.forEach((i, n) => {
                        if (!w[n]) {
                            const r = i.cloneNode(!0),
                                s = w[n];
                            if (s && s.parentNode) s.parentNode.insertBefore(r, s);
                            else {
                                const i = t.querySelector(
                                    `.product-block-content-${e}.variant-changed-update:last-of-type`
                                );
                                if (i) i.after(r);
                                else {
                                    const i = t.querySelector(`.product-block-content-${e}.variant-changed-update`);
                                    i ? i.after(r) : t.prepend(r);
                                }
                            }
                        }
                    });
            }
            this.toggleAddButton(!this.currentVariant.available, window.variantStrings.outOfStock),
                this.setSku(this.currentVariant.sku),
                this.setBarcode(this.currentVariant.barcode),
                this.setProductInfo(t),
                this.updatePickupAvailability(),
                this.updateOptionValues(t);
                
                //  Trustpilot's
                reinitTrustpilotWidgets(
                  document.getElementById(`ProductPage-${sectionId}`) || document,
                );

            const L = new CustomEvent("product:variant-change", { detail: { variant: this.currentVariant } });
            document.dispatchEvent(L),
                publish(PUB_SUB_EVENTS.productVariantChange, { sectionId: e, html: t, variant: this.currentVariant });
        };
    }
    setSku(e) {
        const t = document.querySelectorAll(`.ProductSku-${this.dataset.section}`);
        t.length &&
            (e
                ? t.forEach((t) => {
                      t.parentNode.classList.remove("visually-hidden"), (t.textContent = e);
                  })
                : t.forEach((e) => {
                      e.parentNode.classList.add("visually-hidden");
                  }));
    }
    setBarcode(e) {
        const t = document.querySelectorAll(`.ProductBarcode-${this.dataset.section}`);
        t.length &&
            (e
                ? t.forEach((t) => {
                      t.parentNode.classList.remove("visually-hidden"), (t.textContent = e ?? "");
                  })
                : t.forEach((e) => {
                      e.parentNode.classList.add("visually-hidden");
                  }));
    }
    setProductInfo(e) {
        const t = `#ProductPage-${this.sectionId} .product-info-details-list`,
            i = document.querySelectorAll(t),
            n = e.querySelectorAll(t);
        i.length > 0 &&
            i.forEach((e, t) => {
                n[t] && (e.innerHTML = n[t]?.innerHTML);
            });
    }
    toggleAddButton(e = !0) {
        const t = document.getElementById(`product-form-${this.dataset.section}`);
        if (!t) return;
        const i = t.querySelector('[name="add"]');
        i && (e ? i.setAttribute("disabled", "disabled") : i.removeAttribute("disabled"));
    }
    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e?.querySelector('[name="add"]'),
            i = e?.querySelector('[name="add"] > span'),
            n = document.getElementById(`price-${this.dataset.section}`),
            r = document.getElementById(`ProductPage-${this.dataset.section}`),
            s = document.querySelectorAll(`.product-info-meta-${this.dataset.section}`),
            o = document.getElementById(`ProductStockBar-${this.dataset.section}`);
        t && (i.textContent = window.variantStrings.unavailable),
            n && n.classList.add("visibility-hidden"),
            s.length > 0 &&
                s.forEach((e) => {
                    e.classList.add("visibility-hidden");
                }),
            o && o.classList.add("hidden");
        const a = r?.querySelectorAll(".product-info-details-variant-field .product-info-details-item-value");
        a && a.forEach((e) => (e.innerHTML = "-"));
    }
    getVariantData(e) {
        return JSON.parse(this.querySelector(`script[type="application/json"][data-resource="${e}"]`).textContent);
    }
    getSelectedOptionValues() {
        return Array.from(this.querySelectorAll("select option:checked, fieldset input:checked")).map(
            (e) => e.dataset.optionValueId
        );
    }
}
customElements.get("variant-selects") || customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
}
customElements.define("variant-radios", VariantRadios);
class ProductCard extends HTMLElement {
    constructor() {
        super(),
            (this.colorSwatches = this.querySelectorAll(".card-product-color-swatch")),
            (this.productLinks = this.querySelectorAll("a.js-product-link")),
            this.colorSwatches.forEach((e) => {
                e.addEventListener("click", (t) => {
                    t.preventDefault(), this.handleColorSwatchClick(e);
                }),
                    e.addEventListener("mouseover", () => {
                        this.handleColorSwatchMouseOver(e);
                    });
            });
    }
    handleColorSwatchClick(e) {
        this.colorSwatches.forEach((e) => e.classList.remove("is-active")),
            e.classList.add("is-active"),
            this.productLinks.forEach((t) => {
                t.setAttribute("href", e.getAttribute("href"));
            });
        const t = e.querySelector(".card-media-image"),
            i = this.querySelector(".card-media img:first-child");
        if (t && i) {
            const e = t.cloneNode(!0);
            e.classList.remove("card-variant-image"), i.replaceWith(e);
        }
        const n = e.getAttribute("data-variant-sku"),
            r = this.querySelector("[data-card-sku]");
        r && (r.textContent = n || "");
        const s = this.querySelector("[class*='add-variation-kluslist-']");
        s && (s.dataset.productSku = n || "");
    }
    handleColorSwatchMouseOver(e) {
        const t = e.querySelector(".card-media-image");
        t && ((t.style.display = "inline-block"), t.setAttribute("loading", ""));
    }
}
customElements.define("product-card", ProductCard);
class ExpandableList extends HTMLElement {
    constructor() {
        super(),
            (this.elements = {
                root: this.querySelector("ul"),
                expandableNavs: this.querySelectorAll(".has-sub-menu"),
                expandableToggles: this.querySelectorAll(".navigation-side-toggle"),
            }),
            this.elements.expandableNavs.length &&
                ((this.expandOnArrowsOnly = "true" === this.getAttribute("expand-on-arrows")),
                this.expandOnArrowsOnly ||
                    this.elements.expandableNavs.forEach((e) => {
                        e.querySelector("a").addEventListener("click", this.onToggle.bind(this, e));
                    }),
                this.elements.expandableToggles.forEach((e) => {
                    const t = e.closest(".navigation-side-item");
                    e.addEventListener("click", this.onToggle.bind(this, t));
                }));
    }
    onToggle(e, t) {
        t.preventDefault(), t.stopImmediatePropagation();
        const i = e.querySelector("ul"),
            n = this.getAttribute("close-others");
        if ("true" === i.getAttribute("aria-expanded")) this.onContract(e);
        else if ((this.onExpand(e), n)) {
            [...e.closest("ul").querySelectorAll(":scope > .has-sub-menu")]
                .filter((t) => t !== e)
                .forEach(this.onContract);
        }
    }
    onExpand(e) {
        const t = e.querySelector("ul"),
            i = e.querySelector(".navigation-side-toggle");
        e.classList.add("is-expanded"),
            t.setAttribute("aria-expanded", "true"),
            i &&
                (i.setAttribute("aria-expanded", "true"),
                (i.querySelector("span.visually-hidden").innerHTML = i.dataset.collapseText));
    }
    onContract(e) {
        const t = e.querySelector("ul"),
            i = e.querySelector(".navigation-side-toggle");
        e.classList.remove("is-expanded"),
            t.setAttribute("aria-expanded", "false"),
            i &&
                (i.setAttribute("aria-expanded", "false"),
                (i.querySelector("span.visually-hidden").innerHTML = i.dataset.expandText));
    }
}
customElements.define("expandable-list", ExpandableList);
class QuantityInput extends HTMLElement {
    constructor() {
        super(),
            (this.input = this.querySelector("input")),
            (this.changeEvent = new Event("change", { bubbles: !0 })),
            this.input.addEventListener("change", this.onInputChange.bind(this)),
            this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this))),
            (this.pricingTiers = this.parsePricingTiers());
    }
    quantityUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.validateQtyRules(),
            this.updateTierPriceDisplay(),
            (this.quantityUpdateUnsubscriber = subscribe(
                PUB_SUB_EVENTS.quantityUpdate,
                this.validateQtyRules.bind(this)
            ));
    }
    disconnectedCallback() {
        this.quantityUpdateUnsubscriber && this.quantityUpdateUnsubscriber();
    }
    parsePricingTiers() {
        const e = this.querySelector('script[type="application/json"][data-pricing-tiers]');
        if (!e) return null;
        try {
            const t = JSON.parse(e.textContent);
            return Array.isArray(t) && t.length
                ? t
                      .filter((e) => e && "number" == typeof e.minimum_quantity)
                      .sort((e, t) => e.minimum_quantity - t.minimum_quantity)
                : null;
        } catch (e) {
            return console.warn("[QuantityInput] Failed to parse pricing tiers JSON:", e), null;
        }
    }
    formatPriceNL(e) {
        return Number(e).toFixed(2).replace(".", ",");
    }
    getTierMessage(e) {
        if (!this.pricingTiers || !this.pricingTiers.length) return null;
        const t =
                this.pricingTiers.find((t) => e < t.minimum_quantity) ||
                this.pricingTiers[this.pricingTiers.length - 1],
            i = this.formatPriceNL(t.price),
            n = 1 === t.minimum_quantity ? "stuk" : "stuks";
        return `€ ${i} vanaf ${t.minimum_quantity} ${n}`;
    }
    getActiveTier(e) {
        if (!this.pricingTiers || !this.pricingTiers.length) return null;
        let t = null;
        for (const i of this.pricingTiers) {
            if (!(e >= i.minimum_quantity)) break;
            t = i;
        }
        return t;
    }
    getTierPriceForQuantity(e) {
        const t = this.getActiveTier(e);
        return t ? t.price : null;
    }
    updateTierPriceDisplay() {
        if (!this.pricingTiers) return;
        const e = parseInt(this.input.value, 10) || 1,
            t = this.getActiveTier(e),
            i = this.getTierMessage(e),
            n = this.closest(".js-cart-item") || this.closest("[id^='MiniCartItem-']");
        if (!n) return;
        const r = n.querySelector(".mini-cart-bulk-summary-wrapper .bulk-summary");
        r &&
            ((r.textContent = i),
            r.classList.remove("hidden"),
            this.dispatchEvent(
                new CustomEvent("quantity-input:pricing-tier-change", { bubbles: !0, detail: { quantity: e, tier: t } })
            ));
    }
    onInputChange(e) {
        if (this.closest("cart-items") || this.closest("mini-cart")) {
            const e = parseInt(this.input.max, 10);
            e > 0 && parseInt(this.input.value, 10) > e && (this.input.value = e);
        }
        this.validateQtyRules(), this.checkBackorderNotice(), this.updateTierPriceDisplay();
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = this.input.value,
            i = e.currentTarget.name;
        if (
            ("plus" === i
                ? parseInt(this.input.dataset.min) > parseInt(this.input.step) && 0 == this.input.value
                    ? (this.input.value = this.input.dataset.min)
                    : this.input.stepUp()
                : this.input.stepDown(),
            t !== this.input.value)
        ) {
            this.input.dispatchEvent(this.changeEvent);
            const e = new CustomEvent("product:quantity-update", { detail: { quantity: Number(this.input.value) } });
            document.dispatchEvent(e);
        }
        this.input.dataset.min === t && "minus" === i && (this.input.value = parseInt(this.input.min)),
            this.checkBackorderNotice();
    }
    validateQtyRules() {
        const e = parseInt(this.input.value);
        if (this.input.min) {
            const t = this.querySelector("button[name='minus']");
            t && t.classList.toggle("disabled", parseInt(e) <= parseInt(this.input.min));
        }
        if (this.input.max) {
            const t = parseInt(this.input.max),
                i = this.querySelector("button[name='plus']");
            i && i.classList.toggle("disabled", e >= t);
        }
    }
    checkBackorderNotice() {
        if (this.closest("cart-items") || this.closest("mini-cart")) return;
        const e = document.querySelector(".product-backorder-wrapper");
        if (!e) return void console.log("[BackorderNotice] No .product-backorder-wrapper found — skipping");
        if ("undefined" == typeof _currentOnlineStoreStock || null === _currentOnlineStoreStock)
            return void console.log("[BackorderNotice] _currentOnlineStoreStock is not set yet — skipping");
        const t = "true" === e.dataset.backorderShowBackorder,
            i = parseInt(this.input.value) || 1,
            n = parseInt(_currentOnlineStoreStock) || 0,
            r =
                ("undefined" != typeof _currentPickStoreStock &&
                    null !== _currentPickStoreStock &&
                    parseInt(_currentPickStoreStock)) ||
                0,
            s = Math.max(n, r),
            o = s <= 0,
            a = i > s,
            c = t && (o || a);
        if (
            (console.log("[BackorderNotice] checkBackorderNotice() called"),
            console.log("[BackorderNotice] shouldShow (customer eligible + block enabled):", t),
            console.log("[BackorderNotice] inputQty:", i),
            console.log("[BackorderNotice] onlineStock:", n),
            console.log("[BackorderNotice] pickupStock:", r),
            console.log("[BackorderNotice] effectiveStock (max):", s),
            console.log("[BackorderNotice] isOutOfStock:", o),
            console.log("[BackorderNotice] qtyExceedsStock:", a),
            console.log("[BackorderNotice] willShow:", c),
            (e.style.display = c ? "" : "none"),
            c)
        ) {
            const t = e.querySelector(".backorder-notice__title"),
                i = e.querySelector(".backorder-notice__paragraph");
            if (a && !o) {
                const e = window.themeStrings.back_order_form.qty_exceeds_stock.replace("{{qty_exceeds}}", s);
                t && (t.textContent = e),
                    i && (i.textContent = window.themeStrings.back_order_form.qty_exceeds_para),
                    console.log("[BackorderNotice] reason: qty_exceeds — swapped title with stock:", s);
            } else
                t && (t.textContent = t.dataset.titleOutOfStock),
                    i && (i.textContent = i.dataset.paragraphOutOfStock),
                    console.log("[BackorderNotice] reason: out_of_stock — restored original title and paragraph");
        }
        console.log("[BackorderNotice] wrapper.style.display set to:", "" === e.style.display ? "(visible)" : "none");
    }
}
customElements.define("quantity-input", QuantityInput);
class CartRemoveButton extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", (e) => {
                e.preventDefault();
                const t = this.closest("cart-items"),
                    i = this.closest("mini-cart"),
                    n = this.dataset.key || this.dataset.variantId;
                if (t) {
                    t.updateQuantity(n, 0);
                    const e = document.querySelector(".quotation_event_main_wrapper");
                    e && ((e.innerHTML = ""), (e.style.display = "none"));
                    const i = document.querySelector(".quotation_event_main_sidebar_wrapper");
                    i && ((i.innerHTML = ""), (i.style.display = "none"));
                }
                i && i.updateQuantity(n, 0);
            });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    _renderVersion = 0;
    constructor() {
        super(),
            (this.eventContext = this.dataset.eventContext),
            (this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status")),
            (this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
                (e, t) => e + parseInt(t.value),
                0
            )),
            (this.debouncedOnChange = debounce((e) => {
                this.onChange(e);
            }, 500)),
            this.addEventListener("change", this.syncLineViews.bind(this)),
            (this._loaderShownForPendingChange = !1),
            this.addEventListener("change", (e) => {
                const t = e.target;
                "updates[]" !== t.name ||
                    t.getAttribute("id")?.includes?.("cart-policy") ||
                    t.closest("cart-coupon") ||
                    this._loaderShownForPendingChange ||
                    ((this._loaderShownForPendingChange = !0),
                    window.showPageLoader({ silent: "MINI-CART" === this.tagName }));
            }),
            this.addEventListener("change", this.debouncedOnChange.bind(this));
    }
    connectedCallback() {
        if (!window.CartRecovery) return;
        window.CartRecovery.clearReplay("qty_render");
        const e = window.CartRecovery.getReplay("qty"),
            t = e ? (null != e.lineRef ? e.lineRef : e.variantId) : null;
        if (null == t) return;
        const i = () => this.updateQuantity(t, e.quantity);
        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", i, { once: !0 }) : i();
    }
    syncLineViews(e) {
        const t = e.target;
        if ("updates[]" !== t.name || t.closest("cart-coupon")) return;
        const i = t.dataset.key;
        if (!i) return;
        const n = t.value;
        this.querySelectorAll(`[name="updates[]"][data-key="${i}"]`).forEach((e) => {
            e !== t && (e.value = n);
        });
    }
    onChange(e) {
        this._loaderShownForPendingChange &&
            ((this._loaderShownForPendingChange = !1), window.hidePageLoader({ silent: "MINI-CART" === this.tagName }));
        const t = e.target;
        if ("updates[]" !== t.name || t.getAttribute("id")?.includes?.("cart-policy") || t.closest("cart-coupon"))
            return;
        if (!t.isConnected) return;
        const i = t.dataset.key;
        if (!i) return;
        const n = i,
            r = t.value,
            s = window.CartStore?.peek?.()?.items?.find((e) => e.key === i);
        (s && String(s.quantity) === String(r)) ||
            this.updateQuantity(n, r, document.activeElement.getAttribute("name"));
    }
    getSectionsToRender() {
        return [
            {
                id: "cart-page-title-wrap",
                section: document.getElementById("cart-page-title-wrap")?.dataset.id,
                selector: ".page-title-wrap",
            },
            {
                id: "main-cart-items",
                section: document.getElementById("main-cart-items")?.dataset.id,
                selector: ".js-contents",
            },
            { id: "header", section: document.getElementById("header")?.dataset.id, selector: ".head-slot-cart-link" },
            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
            {
                id: "main-cart-footer",
                section: document.getElementById("main-cart-footer")?.dataset.id,
                selector: ".js-contents",
            },
            {
                id: "mobile-dock",
                section: document.getElementById("mobile-dock")?.dataset.id,
                selector: ".head-slot-cart-link",
            },
        ].filter((e) => {
            const t = document.getElementById(e.id);
            return t && (!e.selector || t.querySelector(e.selector));
        });
    }
    updateQuantity(e, t, i) {
        const n = "string" == typeof e && -1 !== e.indexOf(":"),
            r = this.querySelector(
                n ? `[name="updates[]"][data-key="${e}"]` : `[name="updates[]"][data-variant-id="${e}"]`
            );
        let s = r ? r.dataset.index : void 0;
        console.log("[CartItems.updateQuantity] called — lineRef:", e, "quantity:", t, "name:", i, "domLine:", s),
            this.enableLoading(s),
            window.showPageLoader({ silent: "MINI-CART" === this.tagName });
        const o = JSON.stringify({
            updates: { [e]: Number(t) },
            sections: [...new Set(this.getSectionsToRender().map((e) => e.section))],
            sections_url: window.location.pathname,
        });
        (window.CartQueue ? window.CartQueue.fetch : fetch)(`${routes.cart_update_url}`, {
            ...fetchConfig(),
            body: o,
            failFastOn429: !0,
        })
            .then((i) =>
                429 === i.status && window.CartRecovery
                    ? (window.CartRecovery.reloadAndReplay("qty", { lineRef: e, quantity: t }) ||
                          this.setError(window.cartStrings.error),
                      null)
                    : i.text()
            )
            .then(async (r) => {
                if (null === r) return;
                const o = JSON.parse(r),
                    a = (o.items || []).findIndex((t) => (n ? t.key === e : String(t.variant_id) === String(e)));
                a >= 0 && (s = a + 1),
                    console.log(
                        "[CartItems.updateQuantity] /cart/update.js response — item_count:",
                        o.item_count,
                        "errors:",
                        o.errors,
                        "status:",
                        o.status
                    ),
                    console.log("[CartItems.updateQuantity] lineRef", e, "resolved to REAL cart line:", s);
                const c = document.querySelectorAll(".js-cart-item");
                if (o.errors || (o.status && o.status >= 400))
                    return (
                        console.warn(
                            "[CartItems.updateQuantity] ERROR from /cart/update.js — triggering section re-render. errors:",
                            o.errors,
                            "description:",
                            o.description
                        ),
                        await this.updateSectionContents(!0),
                        void this.updateLiveRegions(s, o.description || o.errors || window.cartStrings.error, e)
                    );
                window.CartRecovery && window.CartRecovery.clearReplay("qty"),
                    window.CartStore && "function" == typeof window.CartStore.setCache && window.CartStore.setCache(o);
                const l = document.querySelector('input[name="delivery_option"]:checked')?.value;
                console.log("[CartItems.updateQuantity] deliveryMethod:", l, "— calling PalletManager.sync()");
                const d = "Store-Pickup" !== l && (await PalletManager.sync());
                console.log("[CartItems.updateQuantity] PalletManager.sync() result — palletChanged:", d);
                let u = null;
                if (d) {
                    await this.updateSectionContents(!0), (u = await window.CartStore.refresh());
                    const e = 0 === u.item_count;
                    this.classList.toggle("is-empty", e);
                    const t = document.getElementById("main-cart-footer");
                    t && t.classList.toggle("is-empty", e),
                        document.querySelectorAll(".mini-cart-count").forEach((e) => {
                            e.textContent = `(${u.item_count})`;
                        });
                } else {
                    this._renderVersion++, this.classList.toggle("is-empty", 0 === o.item_count);
                    const e = document.getElementById("main-cart-footer");
                    e && e.classList.toggle("is-empty", 0 === o.item_count),
                        this.getSectionsToRender().forEach((e) => {
                            const t = document.getElementById(e.id),
                                i = t?.querySelector(e.selector) || t;
                            i &&
                                null != o.sections?.[e.section] &&
                                (i.innerHTML = this.getSectionInnerHTML(o.sections[e.section], e.selector));
                        }),
                        document.querySelectorAll(".mini-cart-count").forEach((e) => {
                            e.textContent = `(${o.item_count})`;
                        });
                }
                const h = u || o,
                    p = o.items[s - 1] ? o.items[s - 1].quantity : void 0;
                let m = "";
                c.length === o.items.length &&
                    p !== parseInt(t) &&
                    (m =
                        "undefined" == typeof p
                            ? window.cartStrings.error
                            : window.cartStrings.quantityError.replace("[quantity]", p)),
                    this.updateLiveRegions(s, m, e);
                const y = document.getElementById(`CartItem-${s}`) || document.getElementById(`MiniCartItem-${s}`);
                if ((y && y.querySelector(`[name="${i}"]`) && y.querySelector(`[name="${i}"]`).focus(), 0 === t)) {
                    const e = new CustomEvent("cart:item-remove", { detail: { cart: h, context: this.eventContext } });
                    document.dispatchEvent(e);
                } else {
                    const e = new CustomEvent("cart:item-quantity-update", {
                        detail: { cart: h, context: this.eventContext },
                    });
                    document.dispatchEvent(e);
                }
                publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: "cart-items",
                    cartData: h,
                    variantId: h.items[s - 1]?.id,
                });
            })
            .catch((e) => {
                (window.CartRecovery &&
                    window.CartRecovery.is429(e) &&
                    window.CartRecovery.reloadAndReplay("qty_render", {})) ||
                    this.setError(window.cartStrings.error);
            })
            .finally(() => {
                this.disableLoading(),
                    window.hidePageLoader({ silent: "MINI-CART" === this.tagName }),
                    cartProductInventoryAPI(),
                    miniCartProductInventoryAPI();
            });
    }
    setError(e) {
        document.getElementById("cart-errors").textContent = e;
    }
    updateLiveRegions(e, t, i) {
        (i
            ? Array.from(this.querySelectorAll(`.cart-item-error[data-key="${i}"]`))
            : [document.getElementById(`Line-item-error-${e}`)].filter(Boolean)
        ).forEach((e) => {
            const i = e.querySelector(".cart-item-error-text");
            i && (i.innerHTML = t);
        }),
            this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        const n = document.getElementById("cart-live-region-text");
        n.setAttribute("aria-hidden", !1),
            setTimeout(() => {
                n.setAttribute("aria-hidden", !0);
            }, 1e3);
    }
    updateSectionContents() {
        const e = ++this._renderVersion,
            t = window.CartQueue ? window.CartQueue.fetch : fetch,
            i = arguments.length > 0 && !0 === arguments[0] ? { failFastOn429: !0 } : void 0;
        return t(
            `${window.location.pathname.startsWith("/search") ? "/" : window.location.pathname}?sections=${[...new Set(this.getSectionsToRender().map((e) => e.section))].join(",")}&v=${Date.now()}`,
            i
        )
            .then((e) => {
                if (429 === e.status) {
                    const e = new Error("cart-section-render-429");
                    throw ((e.status = 429), e);
                }
                return e.json();
            })
            .then((t) => {
                this._renderVersion === e &&
                    this.getSectionsToRender().forEach((e) => {
                        (
                            document.getElementById(e.id)?.querySelector(e.selector) || document.getElementById(e.id)
                        ).innerHTML = this.getSectionInnerHTML(t[e.section], e.selector);
                    });
            });
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    enableLoading(e) {
        document.getElementById("main-cart-items").classList.add("cart-items-disabled"),
            this.querySelectorAll(`#CartItem-${e} .cart-item-loading-overlay`).forEach((e) =>
                e.classList.remove("hidden")
            ),
            this.querySelectorAll(".quantity-input-button").forEach((e) => {
                e.classList.add("disabled"), e.setAttribute("disabled", "");
            }),
            document.activeElement.blur(),
            this.lineItemStatusElement.setAttribute("aria-hidden", !1);
    }
    disableLoading() {
        document.getElementById("main-cart-items").classList.remove("cart-items-disabled"),
            this.querySelectorAll(".cart-item-loading-overlay").forEach((e) => e.classList.add("hidden")),
            this.querySelectorAll(".quantity-input-button").forEach((e) => {
                e.classList.remove("disabled"), e.removeAttribute("disabled");
            });
    }
}
customElements.define("cart-items", CartItems);
class MiniCart extends CartItems {
    constructor() {
        super(), (this.toggle = this.querySelector("drawer-toggle"));
    }
    connectedCallback() {
        Shopify.designMode ||
            this.updateSectionContents().then(() => {
                "function" == typeof applyMiniCartQuantityMax && applyMiniCartQuantityMax();
            }),
            (window.miniCart = this),
            document.addEventListener("open-mini-cart", (e) => {
                this.open(e.detail?.opener || null);
            }),
            document.addEventListener("close-mini-cart", () => {
                this.close();
            }),
            document.addEventListener("toggle-mini-cart", (e) => {
                const t = e.detail?.opener || null;
                this.toggle?.hasAttribute("open") ? this.close() : this.open(t);
            });
    }
    open(e) {
        this.toggle.open(e), this.dispatchEvent(new CustomEvent("mini-cart:opened", { bubbles: !0 }));
    }
    close() {
        this.toggle.close(), this.dispatchEvent(new CustomEvent("mini-cart:closed", { bubbles: !0 }));
    }
    getSectionsToRender() {
        return [
            { id: "header", section: document.getElementById("header")?.dataset.id, selector: ".head-slot-cart-link" },
            { id: "header-mini-cart-content", section: "header-mini-cart-content" },
            { id: "header-mini-cart-footer", section: "header-mini-cart-footer" },
            {
                id: "mobile-dock",
                section: document.getElementById("mobile-dock")?.dataset.id,
                selector: ".head-slot-cart-link",
            },
        ].filter((e) => {
            const t = document.getElementById(e.id);
            return t && (!e.selector || t.querySelector(e.selector));
        });
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        const i = new DOMParser().parseFromString(e, "text/html").querySelector(t);
        return i ? i.innerHTML : null;
    }
    renderContents(e) {
        const t = e && e.sections;
        t &&
            this.getSectionsToRender().forEach((e) => {
                const i = t[e.section];
                if (null == i) return;
                const n = document.getElementById(e.id);
                if (!n) return;
                const r = n.querySelector(e.selector) || n,
                    s = this.getSectionInnerHTML(i, e.selector);
                null != s && (r.innerHTML = s);
            }),
            (this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]')).reduce(
                (e, t) => e + parseInt(t.value),
                0
            )),
            "number" == typeof e.item_count
                ? document.querySelectorAll(".mini-cart-count").forEach((t) => {
                      t.textContent = `(${e.item_count})`;
                  })
                : window.CartStore.refresh()
                      .then((e) => {
                          document.querySelectorAll(".mini-cart-count").forEach((t) => {
                              t.textContent = `(${e.item_count})`;
                          });
                      })
                      .catch(() => {});
    }
    setError(e) {
        document.getElementById("mini-cart-error").textContent = e;
    }
    enableLoading() {
        this.querySelector(".mini-cart-wrap").classList.add("loading");
    }
    disableLoading() {
        this.querySelector(".mini-cart-wrap").classList.remove("loading");
    }
    updateLiveRegions(e, t) {
        const i = document.getElementById(`MiniCart-Line-item-error-${e}`);
        i && (i.querySelector(".cart-item-error-text").innerHTML = t);
    }
}
customElements.define("mini-cart", MiniCart);
class LocalizationForm extends HTMLElement {
    constructor() {
        super(),
            (this.elements = {
                input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
                button: this.querySelector("button"),
                dropdown: this.querySelector(".dropdown"),
                panel: this.querySelector(".dropdown-list-wrap"),
            }),
            this.elements.button.addEventListener("click", this.openSelector.bind(this)),
            this.elements.button.addEventListener("focusout", this.closeSelector.bind(this)),
            this.addEventListener("keyup", this.onContainerKeyUp.bind(this)),
            this.querySelectorAll("a").forEach((e) => e.addEventListener("click", this.onItemClick.bind(this)));
    }
    hidePanel() {
        this.elements.button.blur(),
            this.elements.button.setAttribute("aria-expanded", "false"),
            this.elements.panel.setAttribute("aria-hidden", "true");
    }
    onContainerKeyUp(e) {
        "ESCAPE" === e.code.toUpperCase() && (this.hidePanel(), this.elements.button.focus());
    }
    onItemClick(e) {
        e.preventDefault();
        const t = this.querySelector("form");
        (this.elements.input.value = e.currentTarget.dataset.value), t && t.submit();
    }
    toggleSelector() {
        this.isOpen()
            ? this.hidePanel()
            : (this.elements.button.focus(),
              this.elements.panel.setAttribute("aria-hidden", "false"),
              this.elements.button.setAttribute("aria-expanded", "true"));
    }
    isOpen() {
        return "false" === this.elements.panel.getAttribute("aria-hidden");
    }
    openSelector() {
        this.elements.button.focus(),
            this.elements.panel.setAttribute(
                "aria-hidden",
                "true" === this.elements.button.getAttribute("aria-hidden")
            ),
            this.elements.button.setAttribute(
                "aria-expanded",
                ("false" === this.elements.button.getAttribute("aria-expanded")).toString()
            );
    }
    closeSelector(e) {
        const t = e.relatedTarget && ("BUTTON" === e.relatedTarget.nodeName || "MAIN" === e.relatedTarget.nodeName);
        (null === e.relatedTarget || t) && this.hidePanel();
    }
}
customElements.define("localization-form", LocalizationForm);
class TabsComponent extends HTMLElement {
    constructor() {
        super();
    }
    setActiveTab(e) {
        this.querySelectorAll("[data-handle]").forEach((t) => {
            if ((t.setAttribute("aria-hidden", "true"), t.getAttribute("data-handle") === e)) {
                const e = t.querySelector("carousel-slider");
                t.setAttribute("aria-hidden", "false"), e && e.flickity.resize();
            }
        });
    }
}
customElements.define("tabs-component", TabsComponent);
class TabsNavigation extends HTMLElement {
    constructor() {
        super(),
            (this.sliderId = this.getAttribute("for")),
            (this.navs = this.querySelectorAll("a, button")),
            this.navs.forEach((e) => {
                e.addEventListener("click", this.onNavigationClick.bind(this, e));
            });
    }
    onNavigationClick(e, t) {
        t.preventDefault(), this.setActiveTab(e);
    }
    setActiveTab(e) {
        const t = e.getAttribute("data-handle"),
            i = document.querySelector(`#${this.sliderId}`);
        i &&
            (i.setActiveTab(t),
            this.navs.forEach((t) => {
                t === e ? t.classList.add("is-active") : t.classList.remove("is-active");
            }));
    }
}
customElements.define("tabs-navigation", TabsNavigation);
class DeferredMedia extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector('[id^="Deferred-Poster-"]');
        e && e.addEventListener("click", this.loadContent.bind(this));
    }
    loadContent(e = !0) {
        if ((window.pauseAllMedia(), !this.getAttribute("loaded"))) {
            const t = document.createElement("div");
            t.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0)),
                this.setAttribute("loaded", !0);
            const i = this.appendChild(t.querySelector("video, model-viewer, iframe"));
            e && i.focus();
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class DrawerModal extends HTMLElement {
    constructor() {
        super(),
            (this.bodyClass = this.getAttribute("body-class")),
            (this.isOpen = !1),
            (this.eventPrefix = this.dataset.eventPrefix),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.isOpen && this.close();
            });
    }
    open(e) {
        if (
            ((this.isOpen = !0),
            (this.openedBy = e),
            document.body.classList.add(this.bodyClass),
            document.body.classList.add("drawer-open"),
            DrawerModal.lockBackgroundScroll(this),
            this.eventPrefix)
        ) {
            const e = new CustomEvent(`${this.eventPrefix}:open`);
            document.dispatchEvent(e);
        }
    }
    close() {
        if (
            ((this.isOpen = !1),
            document.body.classList.remove(this.bodyClass),
            document.body.classList.remove("drawer-open"),
            DrawerModal.unlockBackgroundScroll(this),
            this.openedBy && removeTrapFocus(this.openedBy),
            this.eventPrefix)
        ) {
            const e = new CustomEvent(`${this.eventPrefix}:close`);
            document.dispatchEvent(e);
        }
    }
}
customElements.define("drawer-modal", DrawerModal);
// Background scroll lock for open drawers. `overflow: hidden` on the body (.drawer-open)
// is enough on desktop, but iOS Safari ignores it, so the page keeps scrolling behind an
// open drawer and touch gestures leak through to it. This records the offset and tags the
// body; component-drawer.css pins it with position: fixed below the mobile breakpoint only,
// so the breakpoint lives in CSS and desktop behaviour is untouched. The offset is restored
// when the last drawer closes.
DrawerModal.openDrawers = new Set();
DrawerModal.scrollLockY = 0;
DrawerModal.lockBackgroundScroll = function (drawer) {
    if (DrawerModal.openDrawers.has(drawer)) return;
    DrawerModal.openDrawers.add(drawer);
    if (DrawerModal.openDrawers.size > 1) return;
    DrawerModal.scrollLockY = window.scrollY || document.documentElement.scrollTop || 0;
    document.body.style.top = -DrawerModal.scrollLockY + "px";
    document.body.classList.add("drawer-scroll-locked");
};
DrawerModal.unlockBackgroundScroll = function (drawer) {
    if (!DrawerModal.openDrawers.delete(drawer)) return;
    if (DrawerModal.openDrawers.size > 0) return;
    document.body.classList.remove("drawer-scroll-locked");
    document.body.style.top = "";
    window.scrollTo(0, DrawerModal.scrollLockY);
};
class DrawerToggle extends HTMLElement {
    constructor() {
        super(),
            (this.toggleElement = this.querySelector("a") || this.querySelector("button")),
            (this.bodyClass = this.getAttribute("body-class")),
            (this.preventOpen = "true" === this.getAttribute("prevent-open")),
            (this.eventPrefix = this.dataset.eventPrefix),
            this.preventOpen ||
                this.toggleElement.addEventListener("click", (e) => {
                    e.preventDefault(), this.handleToggle();
                });
    }
    handleToggle(e) {
        document.querySelector(`#${this.getAttribute("for")}`).isOpen ? this.close() : this.open(e);
    }
    open(e) {
        const t = document.querySelector(`#${this.getAttribute("for")}`);
        if (t) {
            t.open(e || this.toggleElement);
            const i = t.querySelector(".drawer-header");
            trapFocus(t, i);
        }
    }
    close() {
        const e = document.querySelector(`#${this.getAttribute("for")}`);
        e && e.close && e.isOpen && e.close();
    }
}
customElements.define("drawer-toggle", DrawerToggle);
class CartConsentCheckbox extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        const e = "_CART_CONSENT_CHECKBOX_",
            t = this.querySelector('[type="checkbox"]');
        "checked" === localStorage.getItem(e) && t.setAttribute("checked", !0),
            t.addEventListener("change", function () {
                this.checked ? localStorage.setItem(e, "checked") : localStorage.removeItem(e);
            });
    }
}
customElements.define("cart-consent-checkbox", CartConsentCheckbox);
class BulkAdd extends HTMLElement {
    static ASYNC_REQUEST_DELAY = 250;
    constructor() {
        super(), (this.queue = []), this.setRequestStarted(!1), (this.ids = []);
    }
    startQueue(e, t) {
        this.queue.push({ id: e, quantity: t });
        const i = setInterval(() => {
            this.queue.length > 0 ? this.requestStarted || this.sendRequest(this.queue) : clearInterval(i);
        }, BulkAdd.ASYNC_REQUEST_DELAY);
    }
    sendRequest(e) {
        this.setRequestStarted(!0);
        const t = {};
        e.forEach((e) => {
            t[parseInt(e.id)] = e.quantity;
        }),
            (this.queue = this.queue.filter((t) => !e.includes(t))),
            this.updateMultipleQty(t);
    }
    updateMultipleQty(e) {}
    setRequestStarted(e) {
        this._requestStarted = e;
    }
    get requestStarted() {
        return this._requestStarted;
    }
    resetQuantityInput(e) {
        const t = this.querySelector(`#Quantity-${e}`);
        (t.value = t.getAttribute("value")), (this.isEnterPressed = !1);
    }
    setValidity(e, t, i) {
        e.target.setCustomValidity(i), e.target.reportValidity(), this.resetQuantityInput(t), e.target.select();
    }
    validateQuantity(e) {
        const t = parseInt(e.target.value),
            i = e.target.dataset.index;
        t < e.target.dataset.min
            ? this.setValidity(e, i, window.quickOrderListStrings.min_error.replace("[min]", e.target.dataset.min))
            : t > parseInt(e.target.max)
              ? this.setValidity(e, i, window.quickOrderListStrings.max_error.replace("[max]", e.target.max))
              : t % parseInt(e.target.step) != 0
                ? this.setValidity(e, i, window.quickOrderListStrings.step_error.replace("[step]", e.target.step))
                : (e.target.setCustomValidity(""),
                  e.target.reportValidity(),
                  e.target.setAttribute("value", t),
                  this.startQueue(i, t));
    }
    getSectionInnerHTML(e, t = ".shopify-section") {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
}
function getFocusableElements(e) {
    return Array.from(
        e.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
        )
    );
}
customElements.get("bulk-add") || customElements.define("bulk-add", BulkAdd),
    customElements.get("quick-add-bulk") ||
        customElements.define(
            "quick-add-bulk",
            class extends BulkAdd {
                constructor() {
                    super(),
                        (this.quantity = this.querySelector("quantity-input")),
                        (this.revealHeader = "true" === this.dataset.revealHeader),
                        (this.triggerCart = "true" === this.dataset.triggerCart);
                    const e = debounce((e) => {
                        0 === parseInt(e.target.value)
                            ? this.startQueue(e.target.dataset.index, parseInt(e.target.value))
                            : this.validateQuantity(e);
                    }, 300);
                    this.addEventListener("change", e.bind(this)),
                        this.listenForActiveInput(),
                        this.listenForKeydown(),
                        (this.lastActiveInputId = null);
                }
                connectedCallback() {
                    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
                        const t = parseInt(this.input.value, 10);
                        "quick-add" === e.source ||
                            (0 === t &&
                                e.cartData.items &&
                                !e.cartData.items.some((e) => e.id === parseInt(this.dataset.index))) ||
                            (0 === t &&
                                e.cartData.variant_id &&
                                e.cartData.variant_id !== parseInt(this.dataset.index)) ||
                            this.onCartUpdate().then(() => {
                                this.listenForActiveInput(), this.listenForKeydown();
                            });
                    });
                }
                disconnectedCallback() {
                    this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
                }
                get input() {
                    return this.querySelector("quantity-input input");
                }
                listenForActiveInput() {
                    this.classList.contains("hidden") ||
                        this.input?.addEventListener("focusin", (e) => e.target.select()),
                        (this.isEnterPressed = !1);
                }
                listenForKeydown() {
                    this.input?.addEventListener("keydown", (e) => {
                        "Enter" === e.key && (this.input?.blur(), (this.isEnterPressed = !0));
                    });
                }
                cleanErrorMessageOnType(e) {
                    e.target.addEventListener(
                        "keypress",
                        () => {
                            e.target.setCustomValidity("");
                        },
                        { once: !0 }
                    );
                }
                get sectionId() {
                    return this._sectionId || (this._sectionId = this.dataset.sectionId), this._sectionId;
                }
                onCartUpdate() {
                    return new Promise((e, t) => {
                        (window.CartQueue ? window.CartQueue.fetch : fetch)(this.getSectionsUrl())
                            .then((e) => e.text())
                            .then((t) => {
                                const i = new DOMParser()
                                    .parseFromString(t, "text/html")
                                    .querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
                                i && (this.innerHTML = i.innerHTML), e();
                            })
                            .catch((e) => {
                                console.error(e), t(e);
                            });
                    });
                }
                getSectionsUrl() {
                    const e = new URLSearchParams(window.location.search);
                    return (
                        e.set("section_id", this.sectionId),
                        `${window.location.pathname}${e.toString() ? "?" + e.toString() : ""}`
                    );
                }
                updateMultipleQty(e) {
                    this.setLoading(!0);
                    const t = Object.keys(e),
                        i = JSON.stringify({
                            updates: e,
                            sections: this.getSectionsToRender().map((e) => e.section),
                            sections_url: this.getSectionsUrl(),
                        });
                    (window.CartQueue ? window.CartQueue.fetch : fetch)(`${routes.cart_update_url}`, {
                        ...fetchConfig(),
                        body: i,
                    })
                        .then((e) => e.text())
                        .then((e) => {
                            const i = JSON.parse(e);
                            this.renderSections(i, t),
                                this.revealHeader && document.querySelector("sticky-header")?.reveal?.(),
                                this.triggerCart && document.querySelector("mini-cart")?.open?.(),
                                publish(PUB_SUB_EVENTS.cartUpdate, { source: "quick-add", cartData: i });
                        })
                        .catch((e) => {
                            console.log(e);
                        })
                        .finally(() => {
                            this.setLoading(!1), this.setRequestStarted(!1);
                        });
                }
                setLoading(e = !1) {
                    const t = this.querySelector(".qty-progress-bar-container"),
                        i = this.querySelector(".spinner"),
                        n = this.querySelector(".quantity-success-check");
                    e
                        ? (t.classList.add("visible"), i.classList.add("visible"), n.classList.remove("visible"))
                        : (t.classList.remove("visible"),
                          i.classList.remove("visible"),
                          n.classList.add("visible"),
                          setTimeout(() => n.classList.remove("visible"), 1250));
                }
                getSectionsToRender() {
                    return [
                        {
                            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
                            section: this.sectionId,
                            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
                        },
                        {
                            id: "header",
                            section: document.getElementById("header")?.dataset.id,
                            selector: ".head-slot-cart-link",
                        },
                        { id: "header-mini-cart-content", section: "header-mini-cart-content" },
                        { id: "header-mini-cart-footer", section: "header-mini-cart-footer" },
                        {
                            id: "mobile-dock",
                            section: document.getElementById("mobile-dock")?.dataset.id,
                            selector: ".head-slot-cart-link",
                        },
                    ].filter((e) => {
                        const t = document.getElementById(e.id);
                        return t && (!e.selector || t.querySelector(e.selector));
                    });
                }
                renderSections(e, t) {
                    0 === this.queue.filter((e) => t.includes(e.id)).length &&
                        (this.getSectionsToRender().forEach((t) => {
                            (
                                document.getElementById(t.id).querySelector(t.selector) || document.getElementById(t.id)
                            ).innerHTML = this.getSectionInnerHTML(e.sections[t.section], t.selector);
                        }),
                        this.isEnterPressed && this.querySelector(`#Quantity-${this.lastActiveInputId}`).select(),
                        this.listenForActiveInput(),
                        this.listenForKeydown());
                }
            }
        ),
    document.body.addEventListener("click", (e) => {
        document.body.classList.contains("drawer-open") &&
            (e.target.closest(".drawer") ||
                e.target.closest("drawer-toggle") ||
                [...document.querySelectorAll(".drawer")].forEach((e) => {
                    const t = e.querySelector("drawer-toggle");
                    t && t.close();
                }));
    });
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        n = i[0],
        r = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== r && t.target !== n) ||
                document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() &&
                (t.target !== r || t.shiftKey || (t.preventDefault(), n.focus()),
                (t.target !== e && t.target !== n) || !t.shiftKey || (t.preventDefault(), r.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
try {
    document.querySelector(":focus-visible");
} catch {
    focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
    const e = [
        "ARROWUP",
        "ARROWDOWN",
        "ARROWLEFT",
        "ARROWRIGHT",
        "TAB",
        "ENTER",
        "SPACE",
        "ESCAPE",
        "HOME",
        "END",
        "PAGEUP",
        "PAGEDOWN",
    ];
    let t = null,
        i = null;
    window.addEventListener("keydown", (t) => {
        e.includes(t.code.toUpperCase()) && (i = !1);
    }),
        window.addEventListener("mousedown", (e) => {
            i = !0;
        }),
        window.addEventListener(
            "focus",
            () => {
                t && t.classList.remove("focused"), i || ((t = document.activeElement), t.classList.add("focused"));
            },
            !0
        );
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin),
        document.removeEventListener("focusout", trapFocusHandlers.focusout),
        document.removeEventListener("keydown", trapFocusHandlers.keydown),
        e && e.focus();
}
function debounce(e, t, i) {
    let n;
    return function () {
        const r = this,
            s = arguments,
            o = i && !n;
        clearTimeout(n),
            (n = setTimeout(function () {
                (n = null), i || e.apply(r, s);
            }, t)),
            o && e.apply(r, s);
    };
}
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
function pauseAllMedia() {
    document.querySelectorAll(".js-youtube").forEach((e) => {
        e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
    }),
        document.querySelectorAll(".js-vimeo").forEach((e) => {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }),
        document.querySelectorAll("video").forEach((e) => e.pause()),
        document.querySelectorAll("product-model").forEach((e) => {
            e.modelViewerUI && e.modelViewerUI.pause();
        });
}
document.querySelectorAll(".rte table").forEach(function (e) {
    e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>";
}),
    document.querySelectorAll(".rte iframe").forEach(function (e) {
        (-1 === e.src.indexOf("youtube") && -1 === e.src.indexOf("youtu.be") && -1 === e.src.indexOf("vimeo")) ||
            ((e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>"), (e.src = e.src));
    }),
    "undefined" == typeof window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, n = e.options.length; i < n; i++) {
            var r = e.options[i];
            if (t == r.value || t == r.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i = (t = t || {}).method || "post",
            n = t.parameters || {},
            r = document.createElement("form");
        for (var s in (r.setAttribute("method", i), r.setAttribute("action", e), n)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"),
                o.setAttribute("name", s),
                o.setAttribute("value", n[s]),
                r.appendChild(o);
        }
        document.body.appendChild(r), r.submit(), document.body.removeChild(r);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (r = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                i = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var n = 0; n < i.length; n++) {
                    var r;
                    ((r = document.createElement("option")).value = i[n][0]),
                        (r.innerHTML = i[n][1]),
                        this.provinceEl.appendChild(r);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var i = 0;
            for (t.length; i < t.length; i++) {
                var n = document.createElement("option");
                (n.value = t[i]), (n.innerHTML = t[i]), e.appendChild(n);
            }
        },
    });
class CopyToClipboard extends HTMLElement {
    constructor() {
        super(),
            (this.button = this.querySelector("button")),
            (this.originalText = this.button ? this.button.firstChild.textContent.trim() : ""),
            (this.tooltipText = this.dataset.tooltipText),
            (this.copiedText = this.dataset.copiedText),
            (this.copiedTimeout = null),
            (this.tooltipElement = null);
    }
    connectedCallback() {
        this.button &&
            (this.button.addEventListener("click", this.handleCopy.bind(this)),
            this.button.addEventListener("mouseenter", this.showTooltip.bind(this)),
            this.button.addEventListener("mouseleave", this.hideTooltip.bind(this)),
            this.button.addEventListener("focus", this.showTooltip.bind(this)),
            this.button.addEventListener("blur", this.hideTooltip.bind(this)));
    }
    disconnectedCallback() {
        this.button &&
            (this.button.removeEventListener("click", this.handleCopy.bind(this)),
            this.button.removeEventListener("mouseenter", this.showTooltip.bind(this)),
            this.button.removeEventListener("mouseleave", this.hideTooltip.bind(this)),
            this.button.removeEventListener("focus", this.showTooltip.bind(this)),
            this.button.removeEventListener("blur", this.hideTooltip.bind(this)),
            this.copiedTimeout && clearTimeout(this.copiedTimeout));
    }
    async handleCopy(e) {
        e.preventDefault();
        try {
            await navigator.clipboard.writeText(this.originalText), this.showCopiedState();
        } catch (e) {
            console.error("Failed to copy text: ", e);
        }
    }
    showCopiedState() {
        this.button &&
            (this.updateTooltipText(this.copiedText),
            this.button.classList.add("is-copied"),
            this.copiedTimeout && clearTimeout(this.copiedTimeout),
            (this.copiedTimeout = setTimeout(() => {
                this.button.classList.remove("is-copied"),
                    this.tooltipElement && this.updateTooltipText(this.tooltipText);
            }, 2e3)));
    }
    showTooltip() {
        if (!this.button) return;
        if (this.tooltipElement) return;
        const e = this.button.classList.contains("is-copied") ? this.copiedText : this.tooltipText;
        (this.tooltipElement = document.createElement("div")),
            (this.tooltipElement.className = "copy-tooltip"),
            (this.tooltipElement.textContent = e),
            this.appendChild(this.tooltipElement),
            setTimeout(() => {
                this.tooltipElement?.classList.add("is-visible");
            }, 10);
    }
    hideTooltip() {
        this.tooltipElement &&
            (this.tooltipElement.classList.remove("is-visible"),
            setTimeout(() => {
                this.tooltipElement &&
                    this.tooltipElement.parentNode &&
                    (this.tooltipElement.remove(), (this.tooltipElement = null));
            }, 200));
    }
    updateTooltipText(e) {
        this.tooltipElement && (this.tooltipElement.textContent = e);
    }
}
function getLocaleString(e) {
    return (
        (window.themeStrings &&
            e.split(".").reduce((e, t) => (e && "object" == typeof e ? e[t] : null), window.themeStrings)) ||
        null
    );
}
customElements.define("copy-to-clipboard", CopyToClipboard);
class ToastManager {
    constructor() {
        this.container = document.getElementById("toast-container");
    }
    show({ type: e = "info", title: t = "", message: i = "", duration: n = 4e3, layout: r = "multi" }) {
        if (!this.container) return;
        const s = document.createElement("div");
        (s.className = `toast toast--${e} toast--${r}`),
            (s.innerHTML = `\n      <div class="toast__icon">\n        ${this.getIcon(e)}\n      </div>\n\n      <div class="toast__content">\n        ${"single" === r ? `<div class="toast__single-line">\n                ${t ? `<strong>${t}</strong> ` : ""}\n                ${i}\n              </div>` : `\n              ${t ? `<div class="toast__title">${t}</div>` : ""}\n              <div class="toast__message">${i}</div>\n            `}\n      </div>\n\n      <button class="toast__close" aria-label="Close">\n        ${this.getCloseIcon()}\n      </button>\n    `),
            this.container.appendChild(s),
            s.querySelector(".toast__close").addEventListener("click", () => {
                this.hide(s);
            }),
            n > 0 && setTimeout(() => this.hide(s), n);
    }
    hide(e) {
        e.classList.add("toast--hide"), setTimeout(() => e.remove(), 250);
    }
    getIcon(e) {
        const t = {
            success:
                '\n        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">\n          <circle cx="12" cy="12" r="10" fill="#237659"/>\n          <path d="M7 12l3 3 7-7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n        </svg>\n      ',
            error: '\n        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">\n          <rect x="1" y="1" width="14" height="14" rx="7" fill="#E91616"/>\n          <path d="M5 5L11 11M11 5L5 11" stroke="white" stroke-width="2" stroke-linecap="round"/>\n        </svg>\n      ',
            warning:
                '\n        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">\n          <path d="M2.5 13L8 3.5L13.5 13H2.5Z" fill="#F6CC6F"/>\n        </svg>\n      ',
            info: '\n        <svg width="16" height="16" viewBox="0 0 16 16" fill="none">\n          <circle cx="8" cy="8" r="7" stroke="#4C6DB3" stroke-width="2"/>\n          <circle cx="8" cy="5" r="1" fill="#4C6DB3"/>\n          <rect x="7.5" y="7" width="1" height="4" fill="#4C6DB3"/>\n        </svg>\n      ',
        };
        return t[e] || t.info;
    }
    getCloseIcon() {
        return '\n      <svg width="16" height="16" viewBox="0 0 24 24" fill="none">\n        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>\n      </svg>\n    ';
    }
}
function showTranslatedToast(e, t = "info", i = "multi", n = 4e3) {
    if (!window.toast) return;
    const r = getLocaleString(`toast_notification.${e}.title`),
        s = getLocaleString(`toast_notification.${e}.message`);
    console.log("Toast Title:", r),
        console.log("Toast Message:", s),
        r && window.toast.show({ type: t, title: r, ...(s && { message: s }), layout: i, duration: n });
}
window.toast = new ToastManager();
let lastActiveBulkTier = null,
    originalPriceStore = {};
function getScopeFromElement(e) {
    return (
        (e && (e.closest("quick-view-drawer") || e.closest(".bulk-drawer") || e.closest('[id^="ProductPage-"]'))) ||
        document
    );
}
function toggleApplyButton(e, t) {
    const i = e.querySelector?.(".bulk-drawer") || (e.classList?.contains("bulk-drawer") ? e : null);
    if (!i) return;
    const n = i.querySelector(".bulk-apply-btn");
    n && ((n.disabled = !t), n.classList.toggle("disabled", !t));
}
function buildPriceHTML(e, t) {
    const i = t.querySelector(".custom-unit-pricing");
    let n = e.innerHTML;
    if (i) {
        const e = document.createElement("div");
        e.innerHTML = n;
        const t = e.querySelector(".sale-discount-wrapper");
        t ? t.insertAdjacentHTML("afterend", i.outerHTML) : (e.innerHTML += i.outerHTML), (n = e.innerHTML);
    }
    return n;
}
function updateSticky(e, t) {
    const i = document.querySelector(".sticky-addtocart-panel-left-right-price");
    if (!i) return;
    const n = i.querySelector(".price");
    if (!n) return;
    t.classList.contains("price-on-sale") ? n.classList.add("price-on-sale") : n.classList.remove("price-on-sale");
    let r = n.querySelector(".price-container");
    r || ((r = document.createElement("div")), (r.className = "price-container"), n.prepend(r)),
        (r.innerHTML = e.innerHTML);
    const s = t.querySelector(".custom-unit-pricing");
    let o = n.querySelector(":scope > .custom-unit-pricing");
    s ? (o ? (o.innerHTML = s.innerHTML) : n.appendChild(s.cloneNode(!0))) : o && o.remove();
}
function updateDrawerPrice(e, t, i, n) {
    const r = (e !== document && e.querySelector?.(`#BulkDrawer-${t}`)) || document.querySelector(`#BulkDrawer-${t}`);
    if (!r) return;
    const s = r.querySelector(`#BulkDrawerPrice-${t}`);
    s && (s.innerHTML = buildPriceHTML(i, n));
}
function updateBulkPrice(e) {
    if (!e) return;
    const t = e.querySelector(".quantity-input-field"),
        i = parseInt(t?.value, 10);
    if (!i || i < 1) return;
    const n = e.querySelector('[name="section-id"]')?.value;
    if (!n) return;
    const r = e.closest("quick-view-drawer"),
        s = r || e.closest(`#ProductPage-${n}`) || document.querySelector(`#ProductPage-${n}`) || document;
    if (!s) return;
    let o =
        s.querySelector?.(`#price-${n} .price`) ||
        s.querySelector?.(".drawer-footer .product-block-price .price") ||
        s.querySelector?.(".product-block-price .price");
    if (!o) return;
    const a = o.querySelector(".price-container");
    if (!a) return;
    const c = r ? `qv-${r.realSectionId || n}` : n;
    if (void 0 === window.originalVatSuffixStore[c]) {
        const e = a.querySelector(".mini-cart-price-suffix");
        window.originalVatSuffixStore[c] = e ? e.outerHTML : "";
    }
    const l = window.originalVatSuffixStore[c];
    let d = null,
        u = null;
    const h = s.querySelector?.("variant-selects select option:checked");
    if (h) {
        const e = s.querySelector(`script[data-resource="${h.id}"]`);
        if (e)
            try {
                const t = JSON.parse(e.textContent);
                (d = t.price / 100), (u = t.compare_at_price ? t.compare_at_price / 100 : null);
            } catch (e) {
                console.warn("Failed to parse variant JSON", e);
            }
    }
    const p = e.querySelector('input[name="id"]')?.value || "",
        m = r ? `qv-${r.realSectionId || n}-${p}` : `${n}-${p}`;
    if (null === d) {
        if (((window.originalCompareAtStore = window.originalCompareAtStore || {}), originalPriceStore[m]))
            d = originalPriceStore[m];
        else {
            const e = o.querySelector(".price-item-regular") || o.querySelector(".price-item-sale");
            if (!e) return;
            const t = e.textContent.replace(",", ".").replace(/[^\d.]/g, "");
            if (((d = parseFloat(t)), isNaN(d))) return;
            originalPriceStore[m] = d;
            const i = o.querySelector(".sale-discount-wrapper .price-item-regular");
            if (i) {
                const e = i.textContent.replace(",", ".").replace(/[^\d.]/g, ""),
                    t = parseFloat(e);
                isNaN(t) || (window.originalCompareAtStore[m] = t);
            }
        }
        u = window.originalCompareAtStore[m] || null;
    }
    if (null === d) return;
    let y = null;
    if (
        (s.querySelectorAll(".bulk-tier-radio").forEach((e) => {
            const t = parseInt(e.dataset.minQty, 10);
            i >= t && (!y || t > parseInt(y.dataset.minQty, 10)) && (y = e);
        }),
        !y)
    )
        return renderOriginalPrice(s, o, d, u, n, l), (lastActiveBulkTier = null), void toggleApplyButton(s, !1);
    const g = parseFloat(y.dataset.price) * parseFloat(y.dataset.vatMultiplier || "1"),
        f = u && u > d ? u : d,
        v = Math.round(((f - g) / f) * 100);
    o.classList.add("price-on-sale"),
        toggleApplyButton(s, !0),
        (a.innerHTML = `\n    <div class="price-sale">\n      <span class="price-item price-item-sale price-item-last">\n        € ${((100 * g) / 100).toFixed(2).replace(".", ",")}\n        ${l}\n      </span>\n      <div class="sale-discount-wrapper">\n        <s class="price-item price-item-regular">\n          € ${((100 * f) / 100).toFixed(2).replace(".", ",")}\n        </s>\n        <span class="badge badge-sale">\n          -${v}%\n        </span>\n      </div>\n    </div>\n  `),
        r || updateSticky(a, o),
        updateDrawerPrice(s, n, a, o);
    const b = y.dataset.minQty;
    lastActiveBulkTier !== b &&
        ((lastActiveBulkTier = b),
        "function" == typeof showTranslatedToast && showTranslatedToast("bulk_success", "success", "single", 3500));
}
function renderOriginalPrice(e, t, i, n, r, s = "") {
    t.classList.remove("price-on-sale");
    const o = t.querySelector(".price-container");
    if (!o) return;
    if (n && n > i) {
        const e = Math.round(((n - i) / n) * 100);
        t.classList.add("price-on-sale"),
            (o.innerHTML = `\n      <div class="price-sale">\n        <span class="price-item price-item-sale price-item-last">\n          € ${(Math.floor(100 * i) / 100).toFixed(2).replace(".", ",")}\n          ${s}\n        </span>\n        <div class="sale-discount-wrapper">\n          <s class="price-item price-item-regular">\n            € ${(Math.floor(100 * n) / 100).toFixed(2).replace(".", ",")}\n          </s>\n          <span class="badge badge-sale">\n            -${e}%\n          </span>\n        </div>\n      </div>\n    `);
    } else
        o.innerHTML = `\n      <div class="price-regular">\n        <span class="price-item price-item-regular">\n          € ${(Math.floor(100 * i) / 100).toFixed(2).replace(".", ",")}\n          ${s}\n        </span>\n      </div>\n    `;
    (e && "QUICK-VIEW-DRAWER" === e.tagName) || updateSticky(o, t), r && updateDrawerPrice(e, r, o, t);
}
function syncBulkTier(e, t) {
    t = t || document;
    let i = null;
    t.querySelectorAll(".bulk-tier-radio").forEach((t) => {
        const n = parseInt(t.dataset.minQty, 10);
        e >= n && (!i || n > parseInt(i.dataset.minQty)) && (i = t), (t.checked = !1);
    }),
        i &&
            t.querySelectorAll(`.bulk-tier-radio[data-min-qty="${i.dataset.minQty}"]`).forEach((e) => (e.checked = !0));
}
function updateBulkProgress(e, t) {
    (t = t || document).querySelectorAll(".bulk-progress-wrapper").forEach((i) => {
        const n = i.querySelector(".bulk-qty"),
            r = i.querySelector(".bulk-percentage");
        if (!e || !n || !r || e <= 1) return void (i.style.display = "none");
        const s = [...t.querySelectorAll(".bulk-tier-radio")]
            .map((e) => {
                const t = parseInt(e.dataset.minQty, 10),
                    i = e.closest(".bulk-tier")?.querySelector(".bulk-discount");
                let n = 0;
                if (i) {
                    const e = i.textContent.match(/(\d+)%/);
                    e && (n = parseInt(e[1], 10));
                }
                return { minQty: t, discount: n };
            })
            .filter((e) => !isNaN(e.minQty) && e.discount > 0)
            .sort((e, t) => e.minQty - t.minQty);
        if (!s.length) return (i.style.display = "none");
        const o = s[s.length - 1];
        if (e >= o.minQty) return (i.style.display = "none");
        const a = s.find((t) => e < t.minQty);
        if (!a) return (i.style.display = "none");
        (n.textContent = a.minQty - e), (r.textContent = a.discount + "%"), (i.style.display = "block");
    });
}
function handleQtyChange(e) {
    const t = parseInt(e.value, 10);
    if (!t || t < 1) return;
    const i = e.closest("quick-view-drawer"),
        n = e.closest(".bulk-drawer"),
        r = e.closest('[id^="ProductPage-"]');
    if (!i && !n && !r) return;
    let s;
    s = i
        ? i.querySelector('[name="section-id"]')?.value || "quickview-drawer"
        : n
          ? n.id.replace("BulkDrawer-", "")
          : r.id.replace("ProductPage-", "");
    const o = i || document;
    o
        .querySelectorAll(
            `\n    #ProductPage-${s} .quantity-input-field,\n    #BulkDrawer-${s} .quantity-input-field,\n    .drawer-footer .quantity-input-field,\n    .product-block-product-form .quantity-input-field\n  `
        )
        .forEach((i) => {
            i !== e && (i.value = t);
        }),
        o.querySelectorAll("quantity-input").forEach((e) => {
            "function" == typeof e.validateQtyRules && e.validateQtyRules();
        }),
        syncBulkTier(t, o),
        updateBulkProgress(t, o);
    o.querySelectorAll(
        `\n    #ProductPage-${s} product-form,\n    #BulkDrawer-${s} product-form,\n    .drawer-footer product-form,\n    .product-block-product-form product-form\n  `
    ).forEach((e) => {
        updateBulkPrice(e);
    });
}
(window.originalVatSuffixStore = window.originalVatSuffixStore || {}),
    document.addEventListener("input", (e) => {
        e.target.classList.contains("quantity-input-field") && handleQtyChange(e.target);
    }),
    document.addEventListener("change", (e) => {
        const t = e.target.closest(".bulk-tier-radio");
        if (!t) return;
        const i = t.closest(".bulk-drawer");
        if (i) {
            const e = i.querySelector(".bulk-apply-btn");
            e && ((e.disabled = !1), e.classList.remove("disabled"));
        }
        const n = parseInt(t.dataset.minQty, 10);
        if (!n) return;
        const r = t.closest("quick-view-drawer") || document;
        r.querySelectorAll(".quantity-input-field").forEach((e) => {
            e.value = n;
        });
        const s = r.querySelector(".quantity-input-field");
        s && handleQtyChange(s);
    }),
    document.addEventListener("click", function (e) {
        const t = e.target.closest(".quantity-input-plus"),
            i = e.target.closest(".quantity-input-minus");
        if (!t && !i) return;
        const n = e.target.closest(".quantity-input");
        if (!n) return;
        const r = n.querySelector(".quantity-input-field");
        if (!r) return;
        (n.closest(".bulk-drawer") || n.closest('[id^="ProductPage-"]') || n.closest("quick-view-drawer")) &&
            setTimeout(() => {
                handleQtyChange(r);
            }, 50);
    }),
    document.addEventListener("product:variant-change", (e) => {
        lastActiveBulkTier = null;
        const t = (e.target && getScopeFromElement(e.target)) || document;
        t.querySelectorAll(".quantity-input-field").forEach((e) => {
            e.value = 1;
        }),
            t.querySelectorAll(".bulk-apply-btn").forEach((e) => {
                (e.disabled = !0), e.classList.add("disabled");
            });
    });
let lastFocusedElement = null,
    focusTrapHandler = null;
function closeDrawer(e) {
    const t = document.getElementById("BulkDrawer-" + e),
        i = document.getElementById("BulkOverlay-" + e);
    t &&
        i &&
        (t.classList.remove("is-open"),
        i.classList.remove("is-open"),
        t.setAttribute("aria-hidden", "true"),
        i.setAttribute("aria-hidden", "true"),
        document.body.classList.remove("bulk-drawer-open"),
        releaseFocusTrap(),
        lastFocusedElement && lastFocusedElement.focus());
}
function trapFocus(e) {
    const t = e.querySelectorAll('a, button, textarea, input, select, [tabindex]:not([tabindex="-1"])');
    if (!t.length) return;
    const i = t[0],
        n = t[t.length - 1];
    (focusTrapHandler = function (e) {
        "Tab" === e.key &&
            (e.shiftKey
                ? document.activeElement === i && (e.preventDefault(), n.focus())
                : document.activeElement === n && (e.preventDefault(), i.focus()));
    }),
        document.addEventListener("keydown", focusTrapHandler);
}
function releaseFocusTrap() {
    focusTrapHandler && (document.removeEventListener("keydown", focusTrapHandler), (focusTrapHandler = null));
}
document.addEventListener("click", function (e) {
    const t = e.target.closest("[data-bulk-open]");
    if (t) {
        const e = t.getAttribute("data-bulk-open"),
            i = document.getElementById("BulkDrawer-" + e),
            n = document.getElementById("BulkOverlay-" + e);
        if (!i || !n) return;
        (lastFocusedElement = t),
            i.classList.add("is-open"),
            n.classList.add("is-open"),
            updateApplyButtonState(i),
            i.setAttribute("aria-hidden", "false"),
            n.setAttribute("aria-hidden", "false"),
            document.body.classList.add("bulk-drawer-open"),
            setTimeout(() => {
                i.focus(), trapFocus(i);
            }, 50);
    }
    const i = e.target.closest("[data-bulk-close]");
    if (i) {
        closeDrawer(i.getAttribute("data-bulk-close"));
    }
    const n = e.target.closest(".bulk-drawer-back");
    if (n) {
        const e = n.closest(".bulk-drawer");
        if (!e) return;
        closeDrawer(e.id.replace("BulkDrawer-", ""));
    }
    const r = e.target.closest(".bulk-overlay");
    if (r) {
        closeDrawer(r.id.replace("BulkOverlay-", ""));
    }
    const s = e.target.closest(".bulk-apply-btn");
    if (s) {
        if (s.hasAttribute("disabled")) return;
        const e = s.closest(".bulk-drawer");
        if (!e) return;
        closeDrawer(e.id.replace("BulkDrawer-", ""));
    }
}),
    document.addEventListener("keydown", function (e) {
        if ("Escape" === e.key) {
            const e = document.querySelector(".bulk-drawer.is-open");
            if (!e) return;
            closeDrawer(e.id.replace("BulkDrawer-", ""));
        }
    }),
    document.addEventListener(
        "blur",
        function (e) {
            const t = e.target.closest(".quantity-input-field");
            if (!t) return;
            let i = parseInt(t.value, 10);
            (isNaN(i) || i < 1) && (t.value = 1);
        },
        !0
    );
const PalletManager = (() => {
    let e = null,
        t = !1,
        i = null,
        n = null;
    const r = (e) => {
        const t = parseInt(e, 10);
        return Number.isFinite(t) && t > 0 ? t : 0;
    };
    function s(e, t, i) {
        return t <= 0 || i <= 0 || e <= 0 || e < t
            ? 0
            : 1 +
                  (function (e, t, i) {
                      if (t <= 0 || i <= 0 || e <= 0) return 0;
                      const n = t + i;
                      return e < n ? 0 : 1 + Math.floor((e - n) / i);
                  })(e, t, i);
    }
    async function o(e) {
        (n = null), console.log("[PalletManager] sync() started");
        try {
            const t = await window.CartStore.get();
            if (!t?.items) return console.warn("[PalletManager] No cart or cart items found — aborting"), !1;
            const i = document.querySelector('input[name="delivery_option"]:checked'),
                o = i?.value || t.attributes?.["delivery-method"];
            if (!o) return console.log("[PalletManager] No delivery method selected — skipping sync"), !1;
            if ("Store-Pickup" === o) {
                const e = t.items.find((e) => "true" === e.properties?._isglobalpallet),
                    i = t.items.find((e) => "true" === e.properties?._isglobalsurcharge),
                    n = {};
                return (
                    e && (n[e.key] = 0),
                    i && (n[i.key] = 0),
                    Object.keys(n).length > 0 && (await CartAPI.update({ updates: n }), !0)
                );
            }
            let a = null,
                c = 0,
                l = null,
                d = null,
                u = 0,
                h = null,
                p = !1;
            const m = [];
            let y = !1,
                g = !1;
            t.items.forEach((e) => {
                let t = e.properties || {};
                if ("true" === t._isglobalpallet) return (a = e.key), void (c = e.quantity);
                if ("true" === t._isglobalsurcharge) return (d = e.key), void (u = e.quantity);
                if (!t._pallettype && window.BM_PALLET_META) {
                    const i = window.BM_PALLET_META[e.variant_id];
                    i &&
                        i.pallettype &&
                        (t = Object.assign({}, t, {
                            _pallettype: i.pallettype,
                            _ispallet: i.ispallet,
                            _unitpp: i.unitpp,
                            _extracapacity: i.extracapacity,
                        }));
                }
                !l && t._palletvariantID && (l = t._palletvariantID),
                    !h && t._surchargeVariantID && (h = t._surchargeVariantID),
                    "BM" === t._surchargeType && "true" === t._islargegoods && (p = !0),
                    "BM" === t._pallettype &&
                        ((y = !0),
                        "true" === t._ispallet
                            ? m.push({ qty: e.quantity, min: r(t._unitpp), cap: r(t._extracapacity) })
                            : "false" === t._ispallet && (g = !0));
            });
            const f = m.length > 0;
            window.BM_PALLET_GLOBALS &&
                (l || (l = window.BM_PALLET_GLOBALS.palletVariantId || l),
                h || (h = window.BM_PALLET_GLOBALS.surchargeVariantId || h));
            let v = 0;
            if (y)
                if (g && !f) v = 1;
                else if (f && !g) {
                    let e = 0;
                    for (const t of m) e += s(t.qty, t.min, t.cap);
                    v = e > 0 ? e : 1;
                } else {
                    v = 1;
                    for (const e of m) e.min > 0 && e.cap > 0 && e.qty >= e.min && (v += s(e.qty, e.min, e.cap));
                }
            else v = 0;
            const b = (!0 === window.enableFuelSurcharge || "true" === window.enableFuelSurcharge) && v > 0 ? 1 : 0;
            console.log(
                "[PalletManager] palletsNeeded=" + v,
                "surchargeNeeded=" + b,
                "bmPalletYesLines=" + JSON.stringify(m),
                "hasBMPalletNoItem=" + g,
                "hasLargeGoodsBMItem=" + p
            );
            const S = {},
                w = [],
                E = !0 === window._bmPalletAddInProgress;
            a
                ? (0 !== v && c === v) || (S[a] = v)
                : !E && v > 0 && l && w.push({ id: l, quantity: v, properties: { _isglobalpallet: "true" } }),
                d
                    ? 0 === b
                        ? (S[d] = 0)
                        : 1 !== u && (S[d] = 1)
                    : !E && b > 0 && h && w.push({ id: h, quantity: b, properties: { _isglobalsurcharge: "true" } });
            const L = Object.keys(S).length > 0,
                q = w.length > 0,
                T = !!e && Object.keys(e).length > 0;
            if (!L && !q && !T) return console.log("[PalletManager] No cart changes needed"), !1;
            const k = T && !(q && !L);
            if (L || k) {
                const t = {};
                L && (t.updates = S), k && (t.attributes = e), await CartAPI.update(t);
            }
            return q && (await CartAPI.add(w)), T && !k && (n = e), L || q;
        } catch (e) {
            return console.error("[PalletManager] Error during sync:", e), !1;
        } finally {
            console.log("[PalletManager] sync() complete");
        }
    }
    return {
        sync: function (n) {
            return e
                ? ((t = !0), n && (i = n), console.log("[PalletManager] sync() queued — will re-run after current"), e)
                : ((e = (async function (e) {
                      let n = await o(e);
                      for (; t; ) {
                          t = !1;
                          const e = i;
                          (i = null), (n = (await o(e)) || n);
                      }
                      return n;
                  })(n).finally(() => {
                      e = null;
                  })),
                  e);
        },
        getPendingDeliveryAttrs: () => n,
    };
})();
let resizeTimer;
function disableAnimation() {
    document.documentElement.classList.add("no-animation"),
        document.documentElement.classList.remove("js-animation-ready");
}
function enableAnimation() {
    document.documentElement.classList.remove("no-animation"),
        document.documentElement.classList.add("js-animation-ready");
}
window.addEventListener("load", () => {
    enableAnimation();
}),
    window.addEventListener("resize", () => {
        disableAnimation(),
            clearTimeout(resizeTimer),
            (resizeTimer = setTimeout(() => {
                enableAnimation();
            }, 250));
    }),
    (function () {
        var e = null,
            t = 0,
            i = 0;
        function n() {
            (t = 0), (i = 0), window.hidePageLoader();
        }
        (window.showPageLoader = function (r) {
            var s = document.getElementById("cart-page-loader");
            s &&
                (clearTimeout(e),
                t++,
                (r && r.silent) || i++,
                s.classList.add("is-visible"),
                s.classList.toggle("is-silent", 0 === i),
                s.removeAttribute("aria-hidden"),
                (e = setTimeout(n, 8e3)));
        }),
            (window.hidePageLoader = function (n) {
                var r = document.getElementById("cart-page-loader");
                r &&
                    ((t = Math.max(0, t - 1)),
                    (n && n.silent) || (i = Math.max(0, i - 1)),
                    t > 0
                        ? r.classList.toggle("is-silent", 0 === i)
                        : (clearTimeout(e),
                          r.classList.remove("is-visible"),
                          r.classList.remove("is-silent"),
                          r.setAttribute("aria-hidden", "true")));
            }),
            (window.waitForCartReady = function () {
                return new Promise(function (e) {
                    var t = document.getElementById("cart-page-loader");
                    if (t && t.classList.contains("is-visible")) {
                        var i = !1,
                            n = function () {
                                i || ((i = !0), r.disconnect(), clearTimeout(s), e());
                            },
                            r = new MutationObserver(function () {
                                t.classList.contains("is-visible") || n();
                            });
                        r.observe(t, { attributes: !0, attributeFilter: ["class"] });
                        var s = setTimeout(n, 9e3);
                    } else e();
                });
            });
    })(),
    (function () {
        function e() {
            var e = document.getElementById("JobStepperWrapper");
            if (e) {
                var t = document.querySelectorAll(".job-step__link"),
                    i = document.querySelector('[id$="-roadmap-view"]'),
                    n = i ? i.querySelectorAll(".job-section") : document.querySelectorAll(".job-section"),
                    r = document.querySelector(".header") || document.querySelector("header"),
                    s = document.getElementById("pdp-header-banner");
                if (
                    (h(),
                    s && new MutationObserver(h).observe(s, { attributes: !0, attributeFilter: ["class"] }),
                    t.length && n.length)
                ) {
                    var o = function () {
                            var i = window.scrollY,
                                r = e.offsetHeight + 200,
                                s = document.getElementById("JobStepperProgress"),
                                o = document.querySelectorAll("#JobStepper .job-step").length,
                                a = document.querySelectorAll(".job-step__line");
                            n.forEach(function (e, n) {
                                var c = e.offsetTop - r,
                                    l = c + e.offsetHeight;
                                i >= c &&
                                    i < l &&
                                    (t.forEach(function (e, t) {
                                        e.classList.toggle("is-active", t <= n);
                                    }),
                                    s && o > 0 && (s.style.width = ((n + 1) / o) * 100 + "%"),
                                    a.forEach(function (e, t) {
                                        e.classList.toggle("is-completed", t < n);
                                    }));
                            });
                        },
                        a = !1;
                    window.addEventListener("scroll", function () {
                        a ||
                            (window.requestAnimationFrame(function () {
                                o(), (a = !1);
                            }),
                            (a = !0));
                    }),
                        o();
                }
                var c = document.getElementById("JobStepperToggle"),
                    l = document.getElementById("JobStepperDropdown"),
                    d = document.getElementById("JobStepperSelected"),
                    u = document.querySelectorAll(".job-stepper-mobile__item");
                c &&
                    l &&
                    c.addEventListener("click", function () {
                        l.classList.toggle("is-open");
                    }),
                    u.forEach(function (e) {
                        e.addEventListener("click", function () {
                            u.forEach(function (e) {
                                e.classList.remove("is-active");
                                var t = e.querySelector(".job-stepper-mobile__number");
                                t && t.classList.remove("is-active");
                            }),
                                this.classList.add("is-active");
                            var e = this.querySelector(".job-stepper-mobile__number");
                            e && e.classList.add("is-active");
                            var t = this.querySelector(".job-stepper-mobile__content");
                            if (t && d) {
                                d.innerHTML = t.outerHTML;
                                var i = d.querySelector(".job-stepper-mobile__number");
                                i && i.classList.add("is-active");
                            }
                            l && l.classList.remove("is-open");
                        });
                    });
            }
            function h() {
                var i =
                    (r ? r.offsetHeight : 0) +
                    (s &&
                    s.classList.contains("pdp-header-banner--sticky") &&
                    !s.classList.contains("hidden") &&
                    null !== s.offsetParent
                        ? s.offsetHeight
                        : 0);
                if ((i > 0 && (e.style.top = i + "px"), t.length && n.length)) {
                    var o = i + e.offsetHeight + 20;
                    n.forEach(function (e) {
                        e.style.scrollMarginTop = o + "px";
                    });
                }
            }
        }
        "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e) : e();
    })();
